import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { onError } from "../libs/errorLib";

import { API } from "aws-amplify";
import "./VisitorBook.css";
//import LoaderButton2 from "../components/LoaderButton2";
//import LoaderButton3 from "../components/LoaderButton3";

//import { Modal, CircularProgress } from "@mui/material";


import LoaderButtonX from "../components/LoaderButtonX";
//import "./FineTuner.css";
import RuleInput from "../components/RuleInput"
import LoadingModal from "../components/LoadingModal"
import JSZip from "jszip";
import { saveAs } from "file-saver"; // optional helper for downloads
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';

import { BsArrowRepeat } from "react-icons/bs";


import Table from "react-bootstrap/Table";

import { makeStyles, withStyles, styled } from '@material-ui/core/styles';

import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import QueueIcon from '@material-ui/icons/Queue';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';

import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import Button from '@material-ui/core/Button';
//import Button from "../components/LoaderButtonX";
import Link from '@material-ui/core/Link';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';

import ButtonBase from '@material-ui/core/ButtonBase';


import Fab from '@material-ui/core/Fab';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Chip from '@material-ui/core/Chip';
//import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';

import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

//import LocationOnRoundedIcon from '@material-ui/icons/LocationOnRounded';
//import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';
//import Brightness3Icon from '@material-ui/icons/Brightness3';
//import InvertColorsIcon from '@material-ui/icons/InvertColors';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

//import PictureAsPdfRoundedIcon from '@material-ui/icons/PictureAsPdfRounded';

import iTopOvernightOff from '../images/preview/Pay Per Night - Grey.svg';
import iTopBaysOff from '../images/preview/Parking - Grey.svg';
import iTopFacilitiesOff from '../images/preview/Facilities Only - Grey.svg';

import iTopOvernight from '../images/preview/Pay Per Night - Blue.svg';
import iTopBays from '../images/preview/Parking - Blue.svg';
import iTopFacilities from '../images/preview/Facilities Only - Blue.svg';


import iRecyclingOff from '../images/facilities/Recycling - Grey.svg';
import iBlackWaterOff from '../images/facilities/Black Water Disposal - Grey.svg';
import iElectricOff from '../images/facilities/Electric Hook Up - Grey.svg';
import iGreyWaterOff from '../images/facilities/Grey Water Disposal - Grey.svg';
import iLaundryOff from '../images/facilities/Laundry - Grey.svg';
import iOvernightOff from '../images/facilities/Overnight Parking - Grey.svg';
import iRubbishOff from '../images/facilities/Rubbish - Grey.svg';
import iShowerOff from '../images/facilities/Shower - Grey.svg';
import iToiletOff from '../images/facilities/Toilet - Grey.svg';
import iWaterOff from '../images/facilities/Water - Grey.svg';
import iWifiOff from '../images/facilities/Wifi - Grey.svg';

import iRecycling from '../images/facilities/Recycling - Coral.svg';
import iBlackWater from '../images/facilities/Black Water Disposal - Coral.svg';
import iElectric from '../images/facilities/Electric Hook Up - Coral.svg';
import iGreyWater from '../images/facilities/Grey Water Disposal - Coral.svg';
import iLaundry from '../images/facilities/Laundry - Coral.svg';
import iOvernight from '../images/facilities/Overnight Parking - Coral.svg';
import iRubbish from '../images/facilities/Rubbish - Coral.svg';
import iShower from '../images/facilities/Shower - Coral.svg';
import iToilet from '../images/facilities/Toilet - Coral.svg';
import iWater from '../images/facilities/Water - Coral.svg';
import iWifi from '../images/facilities/Wifi - Coral.svg';



import iCampra from '../images/campra/Campra Accredited - Green.svg';

import defaultSiteImage from '../images/Default-Image-Road.jpg';
import spinner from '../images/Driving-SVG.gif';


import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';


import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';

import Container from '@material-ui/core/Container';


import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import Tooltip from '@material-ui/core/Tooltip';


import Form from "react-bootstrap/Form";

import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline';

import parse from 'html-react-parser';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

import iLogo from "../images/logo.jpg";
import iQRLogo from "../images/qrcode_logo.svg";

import iCampraA from '../images/campra/Campra Accredited - Green.svg';
import iCampraX from '../images/campra/Campra Accredited - Grey.svg';


import QRCode from 'qrcode';
import { createCanvas, loadImage } from "node-canvas";

import '../fonts/Montserrat-Regular-normal.js';

import TextareaAutosize from '@material-ui/core/TextareaAutosize';

import CreatableSelect from "react-select/creatable";


//import Calendar from 'react-calendar';
//import 'react-calendar/dist/Calendar.css';

//import CalendarPicker from 'react-native-calendar-picker';

//import DatePicker from "react-multi-date-picker";
//import { Calendar, DateObject } from "react-multi-date-picker"
////import "react-multi-date-picker/styles/colors/xxx.css"
//import "react-multi-date-picker/styles/colors/red.css"
//import colors from "react-multi-date-picker/plugins/colors"

//import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
//import DateRangeIcon from '@material-ui/icons/DateRange';
//import Collapse from '@material-ui/core/Collapse';


//import Papa from 'papaparse';


//import DownloadCSV from '../components/DownloadCSV';




//import {LlamaParseReader} from "llamaindex";
//import 'dotenv/config'




export default function FineTuner() {


  const history = useHistory();
  //const { userHasAuthenticated, isAuthenticated, isCampra, setShowSites} = useAppContext();


  const [fields, handleFieldChange] = useFormFields({
    email: "",
    reg: "",
  });
  const [tncs, setTncs] = useState(false);

  const { isAuthenticated, isCampra } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [isSwitching, setIsSwitching] = useState(false);
  const [switchingId, setSwitchingId] = useState(null);

  const [open, setOpen] = React.useState([]);
  const [paymentResult, setPaymentResult] = React.useState(false);
  const [sessionValues, setSessionValues] = React.useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [deleteAlertOpen, setDeleteAlertOpen] = useState(false);
  const [alertVals, handleAlertChange] = useFormFields({
    title: "",
    message: "",
  });



  const [currentSite, setCurrentSite] = useState(null);
  const [content, setContent] = useState("");
  const [siteOpen, setSiteOpen] = useState(false);
  //const [base64Image, setBase64Image] = useState("");
  //const [siteCode, setSiteCode] = useState("");
  //const [desc, setDesc] = useState("");
  //const [rules, setRules] = useState("");
  const [address, setAddress] = useState("");
  //const [accreditations, setAccreditations] = useState([]);


  const [sites, setSites] = useState([]);


  const [statusText, setStatusText] = useState("");


  const [calendarVal, onCalendarVal] = useState([
    //new DateObject().setDay(5),
    ///new DateObject().setDay(12).color="red",
    //new DateObject().setDay(14).add(1, "month"),
    //new DateObject().setDay(23).add(1, "month"),

  ]);

  const [closedDatesChanged, setClosedDatesChanged] = React.useState([]);
  const [calendarExpanded, setCalendarExpanded] = React.useState([]);
  const handleExpandCalendarClick = (idx) => {
    const curr = calendarExpanded[idx];
    let newArr = new Array(calendarExpanded.length).fill(false);
    newArr[idx] = !curr;
    setCalendarExpanded(newArr);
  };


  const [forceUpdate, setForceUpdate] = React.useState(false);

  const [dateRange, setDateRange] = useState([
    //new DateObject()
  ])

  const [isUploading, setIsUploading] = useState(false);

  const [docTitle, setDocTitle] = useState("");
  const [docDesc, setDocDesc] = useState("");

  const [docFile, setDocFile] = useState(null);


  const [jobId, setJobId] = useState(null);
  const [docId, setDocId] = useState(null);
  const [isParsing, setIsParsing] = useState(false);
  const [parsingStatus, setParsingStatus] = useState(null);
  const [isArtefacting, setIsArtefacting] = useState(false);
  const [artifactingStatus, setArtifactingStatus] = useState(null);
  const [parsedData, setParsedData] = useState(null);
  const [fileDetails, setFileDetails] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState("");
  //const [selectedModel, setSelectedModel] = useState('gpt-3.5-turbo');

  const [openaiData, setOpenaiData] = useState("");
  const [prompt, setPrompt] = useState("");

  const [files, setFiles] = useState([]);
  const [processingState, setProcessingState] = useState({ currentIndex: -1, isActive: false, userKey: 1 });
  const [isRunning, setIsRunning] = useState(false);
  const [resultsStatus, setResultsStatus] = useState('');
  const [isCancelling, setIsCancelling] = useState(false);
  const [resultsData, setResultsData] = useState("");
  const startTimeRef = useRef(0);


  const [promptUserExtraction, setPromptUserExtraction] = useState("");
  const [promptSysExtraction, setPromptSysExtraction] = useState("");
  const [promptUserClues, setPromptUserClues] = useState("");
  const [promptSysClues, setPromptSysClues] = useState("");

  const [temperature, setTemperature] = useState(0.0);

  const [topP, setTopP] = useState(1.0);

  const [presencePenalty, setPresencePenalty] = useState(0.0);
  const [frequencyPenalty, setFrequencyPenalty] = useState(0.0);

  const [selectedModel, setSelectedModel] = useState("gpt-4.1-mini");



  const [fileUrl, setFileUrl] = useState(null);


  const [instanceKey, setInstanceKey] = useState(0); // for categoryinput component

  const [categories, setCategories] = useState([]);
  const [catCols, setCatCols] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [categoryData, setCategoryData] = React.useState([]);


  const [processIdOptions, setProcessIdOptions] = useState([]);

  const [selectedProcessIdOption, setSelectedProcessIdOption] = useState(null);

  const handleProcessIdChange = (newValue) => {
    setSelectedProcessIdOption(newValue);
    console.log(newValue);
  };

  const handleProcessIdCreate = (inputValue) => {
    // Filter input: only alphanumeric, _ and -
    const filtered = inputValue.replace(/[^A-Za-z0-9_-]/g, "");
    if (!filtered) return; // ignore if nothing valid
    const newOption = { value: filtered, label: filtered };
    //const newOption = { value: inputValue, label: inputValue };
    setProcessIdOptions((prev) => [...prev, newOption]);
    setSelectedProcessIdOption(newOption);
  };

  const customStyles = {
    singleValue: (provided, state) => ({
      ...provided,
      color: "red", // selected item text color
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "white" : "black",  // text inside dropdown
      backgroundColor: state.isSelected ? "red" : "white", // highlight color
      "&:hover": {
        backgroundColor: "lightcoral",
      },
    }),
  };


  const defaultCategories = [
    { key: 0, label: "No Fires." },
    { key: 1, label: "No awnings or camping furniture." },
    { key: 2, label: "Vehicles must be park within an allotted bay." },
    { key: 3, label: "Treat other guests with respect." },
    { key: 4, label: "Keep noise to a minimum. no music after 9pm." },
    { key: 5, label: "Leave no trace." }
  ];

  const models = [
    { value: 'gpt-3.5-turbo', label: 'GPT-3.5 Turbo' },
    { value: 'gpt-4.1', label: 'GPT-4.1' },
    { value: 'gpt-4.1-mini', label: 'GPT-4.1 Mini' },
    { value: 'gpt-4o', label: 'gpt-4o' }
  ];


  const categoriesStrxxx = `{
    "1": {"title": "Transaction Overview",
    "subsections":{
    "1.1":{"title": "Notices, Contacts and Administrative matters re this document"},
    "1.2":{"title": "Deal Summary"}
     }
    }
    
    }`;


  const categoriesStr = `{
"1": {"title": "Transaction Overview",
"subsections":{
"1.1":{"title": "Notices, Contacts and Administrative matters re this document"},
"1.2":{"title": "Deal Summary"},
"1.3":{"title": "Use of Proceeds"},
"1.4":{"title": "Sources & Uses"},
"1.5":{"title": "Capital Structure"}
}
},
"2": {"title": "Company Profile",
"subsections":{
"2.1":{"title": "Business Overview"},
"2.2":{"title": "Corporate History"},
"2.3":{"title": "Legal Structure"},
"2.4":{"title": "Ownership & Sponsors"}
}
},
"3": {"title": "Industry & Market",
"subsections":{
"3.1":{"title": "Industry Overview"},
"3.2":{"title": "Market Position"},
"3.3":{"title": "Competitive Landscape"}
}
},
"4": {"title": "Products & Services",
"subsections":{
"4.1":{"title": "Product/Service Portfolio"},
"4.2":{"title": "Customer Segments"},
"4.3":{"title": "Sales Channels & Distribution"}
}
},
"5": {"title": "Operations",
"subsections":{
"5.1":{"title": "Operational Footprint"},
"5.2":{"title": "Facilities & Assets"},
"5.3":{"title": "Supply Chain & Procurement"}
}
},
"6": {"title": "Management & Employees",
"subsections":{
"6.1":{"title": "Management Team"},
"6.2":{"title": "Organizational Structure"},
"6.3":{"title": "Human Resources"}
}
},
"7": {"title": "Financials",
"subsections":{
"7.1":{"title": "Historical Financials"},
"7.2":{"title": "Pro Forma Financials"},
"7.3":{"title": "Financial Projections"},
"7.4":{"title": "KPIs & Financial Metrics"}
}
},
"8": {"title": "Debt & Liabilities",
"subsections":{
"8.1":{"title": "Existing Debt"},
"8.2":{"title": "New Debt Terms"},
"8.3":{"title": "Debt Maturities"},
"8.4":{"title": "Covenants & Restrictions"}
}
},
"9": {"title": "Risk Factors",
"subsections":{
"9.1":{"title": "Operational Risks"},
"9.2":{"title": "Market Risks"},
"9.3":{"title": "Regulatory & Legal Risks"}
}
},
"10": {"title": "Legal & Compliance",
"subsections":{
"10.1":{"title": "Litigation"},
"10.2":{"title": "Regulatory Environment"},
"10.3":{"title": "Compliance & Permits"}
}
}
}`;




  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);



  const handleCategoryCheckboxChange = (e) => {
    const key = parseInt(e.target.value, 10);
    const checked = e.target.checked;

    setSelectedCategories((prev) =>
      checked ? [...prev, key] : prev.filter((k) => k !== key)
    );

  };


  const handleSelectDocument = (e) => {
    e.preventDefault();




    const fullCats = JSON.parse(categoriesStr);

    console.log(fullCats);
    setSelectedDoc(e.target.value)



    const doc = documents[e.target.value];

    const cats = JSON.parse(doc.content);

    let catOpts = [];
    //let colArr = [3];
    let idx = 0;
    let catidx = 0;
    for (const cat in fullCats) {
      //console.log(cat);
      const col = catidx < 3 ? 0 : catidx < 7 ? 1 : 2;
      catOpts.push({ key: idx, label: cat + " " + fullCats[cat].title, artefactIds: null, status: 0, col: col });
      idx++;
      catidx++;
      //console.log(catOpts);
      for (const subcat in fullCats[cat].subsections) {

        //console.log(subcat + " " + fullCats[cat].subsections[subcat].title);
        //console.log(cats[subcat]);
        const items = cats[subcat];
        catOpts.push({ key: idx, label: subcat + " " + fullCats[cat].subsections[subcat].title, artefactIds: items, status: items ? 1 : 9, col: col });
        idx++;
      }
    }
    console.log(catOpts);


    const colArr = Array.from({ length: 3 }, () => []);
    catOpts.forEach((catItem, index) => {
      console.log(catItem);
      colArr[catItem.col].push(catItem);
    });






    setCatCols(colArr);
    setCategories(catOpts);



    /*
    
       catOpts = [];
        console.log(cats);
         idx = 0;
        for (const cat in cats) {
          const items = cats[cat];
          catOpts.push({key: idx, label:cat, artefactIds: items});
          idx++;
          console.log(cat, items);
        };
        setCategories(catOpts);
    */





  };



  function handleAddCategoryClick() {
    categories.unshift(newCategory);
    categoryData.splice(0, categoryData.length)
    categories.map((cat, index) => {
      categoryData.push({ key: index, label: cat });
    })
    setInstanceKey(i => i + 1);
    setNewCategory("");
  }


  const newCategoryHandler = data => { setNewCategory(data.category) }

  /*
 React.useEffect(() => {
   categories=[];
   categoryData.map((data) => {
     categories.push(data.label)
   })
 }, [categoryData]);
*/

  const handleDeleteCategory = (categoryToDelete) => () => {
    setCategoryData((categories) => categories.filter((cat) => cat.key !== categoryToDelete.key));
  };

  /*
  React.useEffect(() => {
    setCategories(defaultCategories);
  }, []);
  */




  //const [jobId, setJobId] = useState('');
  const systemPromptAppend = 'only output markdown(md) and the page number within the json';

  const promptAppend = `Segment the document into atomic financial artifacts. An artifact is a self-contained, logically complete unit such as a table, paragraph, footnote, chart, or section that expresses a specific idea or content block.

 
  For each artifact:
  - Preserve and return the following metadata:
    - page_number
    - rect (bounding box as [x, y, width, height])
    - headings (a list representing the heading hierarchy, e.g., ["3. Financials", "3.1 Historical Financials"])
    - confidence_score (if available)
    - detected relevant_entities (company names, banks, investors, etc.)
  
  - Identify and apply one or more tags from the list below that best describe the content of the artifact. Each artifact should have at least one tag.
  
  - Also add relevant meta tags:
    - Artefact Type (e.g. text, table, chart, image)
    - Document Section
    - Confidence Score
    - Relevant Entities
  
  Return each artifact as a structured JSON object with the following shape:
  
  {
    "artifact_id": "artifact_001",
    "title": "Liquidity and Capital Resources",
    "type": "table", // or "text", "chart", etc.
    "text": "...",
    "metadata": {
      "page_number": 12,
      "rect": [80, 200, 460, 280],
      "headings": ["3. Financials", "3.2 Liquidity"],
      "confidence_score": 0.97,
      "relevant_entities": ["INEOS", "JPMorgan"]
    },
    "tags": ["30. Cash Flow", "12. Strategy"],
    "meta_tags": ["Artefact Type: table", "Document Section"]
  }
  
  After listing all artifacts, include a final JSON object with a numerical summary of the document:
  
  - total_artifacts: number of artifacts
  - tag_distribution: a breakdown of how many artifacts were tagged with each of the classification items (tag_ids)
  - artifacts_by_type: counts per artifact type (e.g., text, table, chart)
  - artifacts_by_section: counts per top-level document section if available (e.g., "Financials", "Company Overview")
  
  Example format:
  
  {
    "summary": {
      "total_artifacts": 94,
      "tag_distribution": {
        "24. Historical Financials": 14,
        "30. Cash Flow": 6,
        "7. Business Model": 5,
        ...
      },
      "artifacts_by_type": {
        "text": 57,
        "table": 28,
        "chart": 9
      },
      "artifacts_by_section": {
        "Financials": 42,
        "Company Overview": 18,
        ...
      }
    }
  }
  
  Avoid overlapping or fragmented artifacts. Only extract artifacts that are semantically meaningful on their own.
  `;

  const artifactsDoc = `[
    {
      "id": 1,
      "title": "Special Notice Regarding Publicly Available Information",
      "md": "## Special Notice Regarding Publicly Available Information\\n\\nAlcatel-Lucent USA Inc. (the “Borrower”) and Alcatel-Lucent (the “Parent” and, together with its consolidated subsidiaries, the “Company”) represent that the information in this Confidential Information Memorandum (CIM) is either publicly available or does not constitute material non-public information (MNPI). The recipient acknowledges that certain lenders may have received a different CIM with MNPI. The recipient also assumes the risk of receiving MNPI if it communicates with certain listed contacts and acknowledges the need for appropriate compliance procedures. The Company and Joint Lead Arrangers disclaim responsibility for the recipient’s decision to restrict its information access.",
      "categories": ["1.1"]
    },
    {
      "id": 2,
      "title": "Notice to and Undertaking by Recipients",
      "md": "## Notice to and Undertaking by Recipients\\n\\nThis CIM is provided solely for informational purposes by Credit Suisse and Goldman Sachs to prospective lenders evaluating the proposed $1,775m and €250m Senior Secured Credit Facilities (the “Facilities”) for Alcatel-Lucent USA Inc. Acceptance of the CIM constitutes agreement to the confidentiality terms described herein. Recipients must return or destroy the CIM if they do not accept these terms. The recipient agrees to limit disclosure of Evaluation Material and is responsible for its Representatives’ compliance. Disclosure is allowed under legal or regulatory obligation.\\n\\nThe CIM is not guaranteed to be complete or accurate. Recipients must conduct their own due diligence. The Joint Lead Arrangers are acting as principals and assume no fiduciary duty toward recipients. This document contains forward-looking statements subject to material risk and uncertainties.",
      "categories": ["1.1"]
    },
    {
      "id": 3,
      "title": "Disclaimers on Information Reliability and Forward-Looking Statements",
      "md": "## Disclaimers on Information Reliability and Forward-Looking Statements\\n\\nRecipients are reminded that all information in the CIM is for informational purposes only and was sourced by the Joint Lead Arrangers from third parties, including the Company. No guarantees or representations are made regarding its completeness or accuracy. Recipients should perform independent analysis and confirm material information themselves. Forward-looking statements are included and involve substantial risks and uncertainties, including assumptions through 2015. Actual outcomes may vary materially due to numerous operational, legal, economic, and competitive factors, some of which are detailed in Alcatel-Lucent’s 2011 Form 20-F.\\n\\nThis presentation should not be interpreted as a commitment to consummate the financing described.",
      "categories": ["1.1", "9.1", "9.2", "9.3"]
    },
    {
      "id": 4,
      "title": "Roles and Activities of the Joint Lead Arrangers",
      "md": "## Roles and Activities of the Joint Lead Arrangers\\n\\nCredit Suisse and Goldman Sachs, as Joint Lead Arrangers, are full-service financial institutions engaging in a wide array of banking and investment activities. These include trading, advisory, principal investments, and research. Their affiliates may hold investments or positions in Alcatel-Lucent and may commit capital to the Facilities. They may also receive fees or discounts for their role in the syndication. The legal due diligence conducted was based on public filings. Their business activities are independent and at arm’s length from the Recipient’s interests, with no fiduciary duty implied.",
      "categories": ["1.1", "8.2"]
    },
    {
      "id": 5,
      "title": "Confidentiality Agreement Terms and Legal Provisions",
      "md": "## Confidentiality Agreement Terms and Legal Provisions\\n\\nThe Notice and Undertaking governs the use of all Evaluation Material. Unless a definitive agreement is signed, the Recipient has no legal obligation beyond the confidentiality agreement. Breach of this Notice may entitle the Company and Joint Lead Arrangers to equitable relief. The terms remain in effect until either a definitive agreement is executed or one year after the CIM date. New York law governs this agreement. The terms consolidate the full understanding regarding confidentiality and use of Evaluation Material between the parties.",
      "categories": ["1.1", "10.3"]
    },
    {
      "id": 6,
      "title": "Non-GAAP Financial Measures and Adjusted EBITDA",
      "md": "## Non-GAAP Financial Measures and Adjusted EBITDA\\n\\nThe CIM includes non-GAAP measures such as Adjusted Operating Income and Adjusted EBITDA. Adjusted Operating Income excludes restructuring, litigation, disposal gains/losses, and PPA entries. Adjusted EBITDA adds back interest, tax, depreciation, amortization, and other non-cash items. The Adjusted EBITDA margin is defined as Adjusted EBITDA divided by operating revenue. These metrics are used by management to assess performance and debt service capacity but are not directly comparable across companies. A reconciliation is provided in the 2011 Form 20-F.",
      "categories": ["7.1", "7.4"]
    },
    {
      "id": 7,
      "title": "Authorization Letter from Alcatel-Lucent Management",
      "md": "## Authorization Letter from Alcatel-Lucent Management\\n\\nDated 14 December 2012, this letter authorizes the syndication of the proposed Facilities. Alcatel-Lucent management confirms that the information in the CIM is complete and accurate to the best of its knowledge and that forward-looking projections were developed in good faith. However, actual results may materially differ. The Company states that the CIM does not include MNPI. The Joint Lead Arrangers are authorized to distribute the CIM to selected financial institutions under the terms of the Notice and Undertaking.",
      "categories": ["1.1", "1.2"]
    },
    {
      "id": 8,
      "title": "Joint Lead Arrangers Contact List",
      "md": "## Contact List for Credit Suisse and Goldman Sachs\\n\\nThe document includes comprehensive contact information for individuals at Credit Suisse and Goldman Sachs involved in:\\n- Leveraged Finance Origination\\n- Telecom, Media & Technology Coverage\\n- Capital Markets\\n- Corporate Banking\\n- Rating Advisory\\n- Syndicated Loan Sales & Trading\\n- M&A Advisory\\n- Restructuring Finance\\n\\nContacts are based in New York, London, Paris, and San Francisco. Roles include Managing Directors, Directors, VPs, Associates, and Analysts. Email addresses and phone numbers are provided for each contact.",
      "categories": ["1.1"]
    },
    {
      "id": 9,
      "title": "Transaction Overview and Use of Proceeds",
      "md": "## Transaction Overview and Use of Proceeds\\n\\nAlcatel-Lucent USA Inc. (the “Borrower”), a subsidiary of Alcatel-Lucent (the “Parent” and collectively the “Company”), is raising $500 million through an Asset Sale Facility, and an additional $1,275 million and €250 million in Senior Secured Term Loans. The proceeds will be used to:\\n- Refinance near-term debt maturities (via tender offers, open market repurchases, or at maturity)\\n- Provide working capital\\n- Fund general corporate purposes\\n\\nThe existing unsecured revolving credit facility maturing April 2013 will be terminated.\\n\\nPro forma senior secured leverage is 2.4x based on LTM September 2012 Adjusted EBITDA of €689m. Reported LTM revenues and Adjusted EBITDA were €14.5bn and €689m, respectively.\\n\\nThe following existing debt tranches are targeted for refinancing:\\n- €619m 2.875% Series B Convertible Debentures (redeemable June 2013)\\n- €75m 2.875% Series A Convertible Debentures (redeemable June 2015)\\n- €462m 6.375% Senior Unsecured Notes due April 2014\\n- €1,000m 5.000% OCEANE Convertible Bonds due January 2015\\n- €500m 8.500% Senior Unsecured Notes due January 2016\\n\\nThese steps support liquidity and strategic flexibility, including non-core asset sales expected to yield €1.0–1.5bn.",
      "categories": ["1.2", "1.3"]
    },
    {
      "id": 10,
      "title": "Sources and Uses of Funds",
      "md": "## Sources and Uses of Funds\\n\\n| Sources                | €m   | $m    | Uses                    | €m   | $m    |\\n|------------------------|------|-------|-------------------------|------|-------|\\n| New Asset Sale Facility| 387  | 500   | Cash on Balance Sheet   | 1,550| 2,004 |\\n| New US$ Term Loan      | 986  | 1,275 | Transaction Fees/Expenses| 73   | 94    |\\n| New EUR Term Loan      | 250  | 323   |                         |      |       |\\n| **Total Sources**      |1,623 | 2,098 | **Total Uses**          |1,623 | 2,098 |\\n\\nThis financing structure provides funding for balance sheet liquidity, refinancing activities, and transaction-related costs.",
      "categories": ["1.4"]
    },
    {
      "id": 11,
      "title": "Pro Forma Capital Structure",
      "md": "## Pro Forma Capital Structure\\n\\nPost-transaction, Alcatel-Lucent's capital structure will include new senior secured debt and legacy unsecured debt across multiple maturities. Total debt post-transaction is €6.4bn ($8.3bn) with a net debt position of €157m ($203m). Senior secured leverage will be 2.4x and total leverage 3.2x LTM EBITDA.\\n\\nDebt includes:\\n- New facilities: $500m Asset Sale Facility, $1,275m and €250m Senior Secured Term Loans\\n- Existing bonds and notes: Convertible Debentures (Series A/B), 7.75% 2017 Notes, 6.45% 2029 Notes, 8.5% 2016 Notes\\n- Undrawn €837m revolver\\n\\nCash on hand post-transaction is €6.3bn ($8.1bn), creating substantial liquidity for debt management and operations.\\n\\nTwo charts (Figure 1 and 2) show current vs. pro forma maturity profile, highlighting the smoothing of near-term obligations.",
      "categories": ["1.5", "7.2"]
    },
    {
      "id": 12,
      "title": "Key Terms of Senior Secured Credit Facilities",
      "md": "## Key Terms of Senior Secured Credit Facilities\\n\\n**Borrower**: Alcatel-Lucent USA Inc.  \\n**Amount**:\\n- Asset Sale Facility: $500m, 3.5 years, LIBOR+600bps, 98.0 OID\\n- Senior Secured Term Loans: $1,275m + €250m, 6 years, LIBOR+700bps, 1% amort., 98.0 OID\\n\\n**Use of Proceeds**: Refinance existing debt, working capital, and general corporate purposes  \\n**Call Protection**: NC1, then 102%, 101%, par thereafter\\n\\n**Security**:\\n- First-priority liens over equity interests, IP, and substantially all other tangible/intangible assets\\n- 90–95% of registered patents targeted for perfection within 90 days post-close\\n\\n**Covenants**:\\n- Affirmative: Customary for facility type\\n- Negative: Based on 8.5% Senior Notes, including restrictions on dividends, liens, indebtedness, hedging, M&A, and asset sales\\n\\n**Financial Covenant**: Maximum senior secured net leverage ratio  \\n**Governing Law**: New York",
      "categories": ["8.2", "8.4", "1.2"]
    },
    {
      "id": 13,
      "title": "Pro Forma Group Structure and Guarantee Details",
      "md": "## Pro Forma Group Structure and Guarantee Details\\n\\nThe new Senior Secured Credit Facilities will be guaranteed by:\\n- Alcatel-Lucent (Parent)\\n- Holdings\\n- The Borrower\\n- Material subsidiaries in the US, France, UK, Canada, and Brazil\\n\\nGuarantees are excluded where:\\n- Legally prohibited (e.g., China, India)\\n- They trigger adverse tax consequences\\n- Costs outweigh benefits\\n\\nCollateral includes:\\n- First-priority lien on equity of Holdings and Borrower\\n- Material IP rights in the US and France\\n- Intercompany loans and most personal property\\n\\nExclusions:\\n- Real estate\\n- Cash and equivalents\\n- Factored receivables\\n- Non-beneficial perfection (cost exceeds benefit)\\n\\nA simplified organizational chart illustrates debt locations and the layering of secured and unsecured claims, showing benefit of subordinated guarantees in some instruments.",
      "categories": ["1.5", "8.2", "8.4"]
    },
    {
      "id": 14,
      "title": "Company Introduction and Innovation Footprint",
      "md": "## Company Introduction and Innovation Footprint\\n\\nAlcatel-Lucent is a globally recognized communications solutions provider, serving service providers, enterprises, and governments. With a footprint in over 130 countries, the Company operates one of the largest and most experienced global services organizations in the industry.\\n\\nHome to Bell Labs, a premier research center, Alcatel-Lucent has been behind transformative innovations such as the transistor and the C programming language. As of LTM September 2012, the Company reported €14.5bn in revenue.\\n\\nIn 2011, the Company invested €2.4bn in R&D and held approximately 30,000 active patents. Bell Labs has been recognized with seven Nobel prizes. Alcatel-Lucent was named one of MIT Technology Review's 2012 Top 50 Most Innovative Companies for innovations like lightRadio™, which improves wireless efficiency and speed.\\n\\n**Figure 4** provides:\\n- Revenue breakdown by region (LTM Sep-2012):\\n  - North America: 39%\\n  - Europe: 27%\\n  - Asia Pacific: 18%\\n  - Rest of World: 16%\\n- Global footprint of research, development, and executive briefing centers.\\n\\n**Source**: Company data",
      "categories": ["2.1", "2.2", "5.1"]
    },
    {
      "id": 15,
      "title": "Strategic Vision and Performance Program",
      "md": "## Strategic Vision and Performance Program\\n\\nAlcatel-Lucent’s strategy is anchored in its High Leverage Network™ (HLN) vision — a converged, all-IP network architecture. HLN supports wired and wireless broadband access, dynamically allocating bandwidth and managing traffic quality based on service needs. It is designed for both developed and emerging markets, offering cost-effective and intelligent network solutions.\\n\\nIn response to challenging macro conditions and changes in customer behavior (e.g., delayed LTE roll-outs), the Company initiated a Performance Program in 2012 focused on:\\n\\n1. Exploiting long-term growth trends in IP and Optical markets\\n2. Leveraging leadership in IP, Optical, and VDSL/FTTX for all-IP infrastructure\\n3. Driving disruptive innovation through Bell Labs\\n4. Monetizing the patent portfolio more effectively\\n5. Restructuring and exiting unprofitable geographies\\n\\nThis program aims to streamline the cost base and sharpen focus on high-growth, high-margin opportunities.",
      "categories": ["2.1", "2.2", "4.1"]
    },
    {
      "id": 16,
      "title": "Operating Segments Overview",
      "md": "## Operating Segments Overview\\n\\nAlcatel-Lucent operates through three core segments, each aligned with its HLN strategy:\\n\\n1. **Networks**: Offers IP-enabled, scalable multi-access network infrastructure. Covers IP routing, optical transport (including submarine systems), fixed broadband, core networks, wireless access, and radio frequency systems. R&D is integrated across these technologies.\\n\\n2. **Software, Services & Solutions**: Provides software tools and services to telecom operators and strategic industries. Solutions help reduce network costs and accelerate the rollout of innovative services, supporting revenue growth and customer retention.\\n\\n3. **Enterprise**: Delivers voice and data networking solutions to enterprise clients.\\n\\n**Figure 5** presents a detailed overview of these segments based on LTM Sep-2012 results (excluding Genesys). Segment performance is also linked to market shares reported in the 2011 Annual Report.\\n\\n**Source**: Company",
      "categories": ["2.1", "4.1"]
    },
    {
      "id": 17,
      "title": "Operating Segment Breakdown – Figure 5 Overview",
      "md": "## Operating Segment Breakdown – Figure 5 Overview\\n\\n**Figure 5** summarizes Alcatel-Lucent's operating segments based on LTM figures as of 30 September 2012 (excluding Genesys). Segment revenue is noted as a percentage of total revenue. Market shares are based on 2011 Company data.\\n\\n### Networks (61% of Revenues)\\n- **Revenue**: €8,873m  \\n- **Adjusted Profit**: (€268m)  \\n- **Margin**: (3.0%)  \\n\\n**Subsegments:**\\n- **IP (13%)** (€1,847m)\\n  - Products: Edge routers, core routers, mobile backhaul, content delivery networks\\n  - Market Position:\\n    - No. 2 in IP edge routers (23%)\\n    - No. 1 in mobile backhaul (25%)\\n\\n- **Optics (15%)** (€2,234m)\\n  - Products: WDM, SDH/SONET, submarine, wireless transmission\\n  - Market Position:\\n    - No. 2 in terrestrial optical networking (16%)\\n    - No. 2 in WDM long haul (17%)\\n    - No. 1 in submarine optical networking (35–40%)\\n\\n- **Wireless (23%)** (€3,393m)\\n  - Products: LTE, CDMA, WCDMA, TD-SCDMA, GSM, small cells, lightRadio™\\n  - Market Position:\\n    - No. 1 in CDMA (37%)\\n    - No. 2 in LTE (24%)\\n    - No. 4 in W-CDMA Radio Access Networks (10%)\\n    - No. 5 in GSM/GPRS/EDGE (7%)\\n\\n- **Wireline (10%)** (€1,440m)\\n  - Products: Fibre access (PON), copper access (XDSL)\\n  - Market Position:\\n    - No. 1 in broadband access (37% DSL)\\n    - No. 1 in VDSL2 (44%)\\n    - No. 2 in GPON (24%)\\n\\n### Software, Services & Solutions (31% of Revenues)\\n- **Revenue**: €4,492m  \\n- **Adjusted Profit**: €232m  \\n- **Margin**: 5.2%\\n\\n**Subsegments:**\\n- **Network Applications (3%)** (€447m)\\n  - Services: IMS, payment & charging, application enablement, customer experience\\n  - Market Position:\\n    - 98 IMS customer projects (8 of top 10 global mobile operators)\\n    - No. 4 in IMS Core (15%)\\n\\n- **Services (28%)** (€4,047m)\\n  - Services: Network/system integration, managed & outsourcing, multi-vendor maintenance, product-attached services\\n  - Market Position:\\n    - No. 3 in overall services market\\n    - No. 2 in OSS/BSS integration\\n    - 190+ payment customers (including top 10 mobile operators)\\n    - 200+ subscriber data management deployments (>1bn subscribers)\\n\\n### Enterprise (5% of Revenues)\\n- **Revenue**: €772m  \\n- **Adjusted Profit**: (€9m)  \\n- **Margin**: (1.2%)\\n- Services: Voice, data & unified communications, enterprise networks & data centers\\n\\n### Other (3% of Revenues)\\n- **Revenue**: €363m  \\n- **Adjusted Profit**: (€53m)  \\n- **Margin**: (14.6%)\\n- Functions: Bell Labs, Intellectual Property & Standards\\n\\n**Source**: Company  \\n**Note**: Segment data excludes Genesys. Market shares are from the 2011 Annual Report.",
      "categories": ["2.1", "4.1", "7.1"]
    },
    {
      "id": 18,
      "title": "Simplified Group Structure – Figure 3",
      "md": "## Simplified Group Structure – Figure 3\\n\\nThis diagram presents the organizational and capital structure of Alcatel-Lucent and its key subsidiaries as of 30 September 2012. It also shows the location of various outstanding debt instruments and how the new Senior Secured Facilities fit into the group's capital stack.\\n\\n### Parent Entity:\\n- **Alcatel-Lucent (France)**: 100% ownership of all listed subsidiaries\\n\\n### Subsidiaries and Sub-Groups:\\n- **Coralec** → **Alcatel Holdings Canada Ltd.** → **Alcatel-Lucent Canada Inc.** (Subordinated guarantee structure)\\n- **Alcatel-Lucent Submarine Networks**\\n- **Other Operating Subsidiaries**\\n- **Alcatel-Lucent Participations**\\n- **Alcatel-Lucent Holdings Inc. USA**\\n- **Alcatel-Lucent USA Inc.** → split into:\\n  - Guarantor Subsidiaries\\n  - Non-Guarantor Subsidiaries\\n\\n### Senior Secured Facilities:\\n- Issued by **Alcatel-Lucent USA Inc.**\\n- Benefit from guarantees by various entities within the group\\n\\n### Notable Debt Instruments:\\n- €1,000m 5.00% Oceane (Convertible/Exchangeable) due Jan-2015\\n- €462m 6.375% Bonds due Apr-2014*\\n- €500m 8.50% Senior Notes due Jan-2016\\n\\n### Convertible Trust and Subordinated Debt:\\n- €747m / US$931m Convertible Trust Preferred Securities due Mar-2017**\\n- €75m / US$95m Convertible Bonds Series A due Jun-2023***\\n- €619m / US$765m Convertible Bonds Series B due Jun-2025***\\n- €209m 6.50% / US$300m Bonds due Jan-2028\\n- €947m 6.45% / US$1,360m Bonds due Mar-2029\\n\\n### Guarantee Structure:\\n- **Parent Subordinated Guarantee** for select instruments (e.g., Convertible Bonds)\\n- **Subordinated Guarantee** from Alcatel-Lucent USA Inc. to the Convertible Trust\\n- **Senior Secured Facilities** are structurally senior to most other instruments, and are backed by guarantees from the group and security over assets where perfected\\n\\n**Note**: \\n- * Benefit from subordinated guarantee from Alcatel-Lucent USA Inc.  \\n- ** Issued by Lucent Technologies Capital Trust I; Alcatel-Lucent USA Inc. obligation is subordinated  \\n- *** Benefit from subordinated guarantee from Alcatel-Lucent (Parent)\\n\\n**Source**: Alcatel-Lucent quarterly financial statements (Q3 2012)",
      "categories": ["1.5", "8.2"]
    },
    {
      "id": 19,
      "title": "Debt Maturity Profile – Figures 1 & 2",
      "md": "## Debt Maturity Profile – Figures 1 & 2\\n\\nThis artefact presents a visual comparison of Alcatel-Lucent’s debt maturity schedule before and after the proposed refinancing transaction involving new Senior Secured Term Loans (TLB), assuming a 6-year maturity.\\n\\n### **Figure 1: Current Debt Maturity Profile (Q3 2012)**\\n- **Cash & Cash Equivalents:** €4,705m\\n- **Debt Maturities:**\\n  - 2013: €619m\\n  - 2014: €462m\\n  - 2015: €1,075m\\n  - 2016: €500m\\n  - 2017: €747m\\n  - 2020 and Thereafter: €1,156m\\n\\n### **Figure 2: Pro Forma Debt Maturity Profile (Assuming 6-Year TLB)**\\n- **Pro Forma Cash & Cash Equivalents:** €6,255m\\n- **Pro Forma Debt Maturities:**\\n  - 2013: €12m (down from €619m)\\n  - 2014: €12m (down from €462m)\\n  - 2015: €12m (down from €1,075m)\\n  - 2016: €899m (€500m + €399m TLB component)\\n  - 2017: €12m (down from €747m)\\n  - 2018: €1,174m\\n  - 2020 and Thereafter: €1,156m\\n\\n### Key Implications:\\n- The transaction significantly improves short-term liquidity and extends the maturity profile.\\n- Near-term maturities (2013–2015) are sharply reduced.\\n- Cash reserves increase by ~€1.5bn post-transaction.\\n\\n**Note:** Maturity profile excludes “Other financial debt”. Values reflect maturities when due and at reported amounts for all outstanding debt as of Q3 2012 per Company consolidated financial statements.",
      "categories": ["1.5", "7.2", "8.3"]
    },
    {
      "id": 20,
      "title": "Key Credit Highlights",
      "md": "## V. Key Credit Highlights\\n\\n### 1) Alcatel-Lucent Positioned to Benefit from Strong Secular Trends\\n\\n**Exponential Data Growth:**\\n- Driven by widespread internet access, smartphones, tablets, video streaming (e.g., YouTube, Netflix), and high-performance technologies like 4G and fiber.\\n- Bell Labs forecasts 54% CAGR in data traffic from 2011 to 2016.\\n\\n**Impact on Networks:**\\n- Developed markets require performance upgrades (e.g., LTE, fiber).\\n- Emerging markets require new infrastructure.\\n- Service providers are under pressure to invest selectively, often constrained by regulation and financial performance.\\n\\n**Opportunity for Equipment Makers:**\\n- Demand for traffic optimization and all-IP architecture is rising.\\n- Solutions like HetNet, small cells, CDNs, and DPI are key trends.\\n\\n**Alcatel-Lucent's Position:**\\n- Positioned to integrate devices, network, and software.\\n- Focused on all-IP infrastructure spanning access, backhaul, edge, and core.\\n- Key strategic areas: IP, Optics, LTE.\\n\\n### 2) Focused Leadership in Profitable and Growing Markets\\n\\n**IP Market:**\\n- €14bn TAM, growing at 9% CAGR (2011–2015).\\n- Alcatel-Lucent is a leader in edge routers with 23% market share in 2011.\\n- Launched 7950 XRS-40 core router with industry-leading specs.\\n\\n**Optics Market:**\\n- €12bn terrestrial optics market (5% CAGR), €2bn submarine optics.\\n- #2 in terrestrial (16% share), #1 in submarine (43% share).\\n- Only vendor with integrated IP and optics portfolios.\\n\\n**LTE and Small Cells:**\\n- LTE market growing at 55% CAGR (2011–2015).\\n- 24% global LTE share; clients include Verizon and AT&T.\\n- Leader in Small Cells (93% CAGR expected).\\n\\n### 3) Deep Strategic Relationships\\n\\n**Clients:**\\n- Major global carriers: AT&T, Verizon, BT, Deutsche Telekom, China Mobile, NTT DoCoMo, etc.\\n- Strategic integration with customers; significant recent wins across IP, Wireless, and Optics segments.\\n\\n### 4) Unique Intellectual Property Portfolio\\n\\n**Portfolio:**\\n- ~30k issued, ~15k pending patents.\\n- Coverage across 70+ technologies, 40+ countries, and 350+ standard essential patents.\\n- Strong US presence enhances value.\\n\\n**Comparables:**\\n- Benchmarking vs. Nortel, MMI, Interdigital.\\n- Implied valuation from precedents: €7–23bn.\\n\\n**Peer Comparison:**\\n- Nokia and Ericsson show licensing revenues >€400m p.a.\\n- Alcatel-Lucent historically under-monetized (~€200m p.a.)\\n\\n**Monetization Strategy:**\\n- Engaged Global IP Law Group and RPX.\\n- Created profit center for IP; hired Craig Thompson (ex-Nokia).\\n\\n**Valuation:**\\n- DCF-based patent valuation ~€5bn (conservative estimate).\\n\\n**Conclusion:**\\n- Strong positioning across core growth technologies (IP, LTE, Optics).\\n- Deep customer relationships and one of the most valuable IP portfolios in telecom.\\n- Strategic initiatives underway to unlock IP value and reinforce core market positions.",
      "categories": ["3.1", "3.2", "3.3", "4.1", "4.2", "7.3", "9.1"]
    },
    {
      "id": 22,
      "title": "Turnaround Plan and Strategic Transformation",
      "md": "## 5) Turnaround Plan Underway – Strategic Vision Plus Operational Excellence\\n\\nIn response to the deteriorating macro environment, deep technological changes, and the slowdown in European service providers’ LTE roll-out, Alcatel-Lucent decided in summer 2012 to re-focus its strategy. This included initiating a significant cost-saving exercise to restructure the organization accordingly.\\n\\n### Strategic Pillars\\n1. Leverage long-term trends in IP and Optical carrier network infrastructure.\\n2. Exploit leadership in IP, Optical, and VDSL/FTTX Fixed Broadband Access to support all-IP infrastructure.\\n3. Capitalize on disruptive innovations at Bell Labs.\\n4. Treat the patent portfolio as a profit center.\\n5. Restructure cost base and exit/restructure unprofitable geographies/markets.\\n\\n### Performance Program\\nAnnounced on July 26, 2012, this restructuring plan aimed to achieve €1.25bn in cost savings by end-2013 (€500m in 2012 and €750m in 2013). Key elements:\\n- Global headcount reduction of ~5,500\\n- Exit/restructure 15 managed services contracts (5 by year-end)\\n- Exit/restructure unprofitable markets\\n- Manage patent portfolio for profit\\n\\n**Targeted Financial Outcomes:**\\n- Gross margins of ~35–37%\\n- Adjusted operating margins of 6–9% by 2015",
      "categories": ["5.3", "7.3"]
    },
    {
      "id": 23,
      "title": "Liquidity, Maturity Profile and Asset Sales",
      "md": "## 6) Appropriate Liquidity and Maturity Profile to Execute Plan\\n\\nThe proposed transaction enhances strategic and operational flexibility. As of Q3 2012, Alcatel-Lucent had €4.7bn in cash and liquid assets. Post-transaction, liquidity increases to €6.3bn.\\n\\n**Key Liquidity Initiatives:**\\n- Manage near-term debt maturities proactively\\n- Dispose of non-core assets to raise €1bn–€1.5bn\\n\\n### Debt Maturity Profile Charts\\n- **Figure 18:** Current Debt Maturity Profile\\n- **Figure 19:** Pro-forma Debt Maturity Profile (Assuming 6-Year TLB)\\n\\n> Note: Excludes “Other financial debt.” Based on Q3 2012 consolidated financials. \\n\\nThis liquidity profile supports Alcatel-Lucent’s transformation and positions the company to return to profitability and positive cash generation.",
      "categories": ["7.1", "8.3"]
    },
    {
      "id": 24,
      "title": "Experienced Management Team Driving Turnaround",
      "md": "## 7) Experienced Management Team Focused on Turnaround\\n\\n### Executive Team\\n- **Ben Verwaayen (CEO)** – 36 years in telecoms\\n- **Paul Tufano (CFO & COO)** – 30+ years in finance and ops\\n- **Philippe Keryer** – Head of Networks & Platforms\\n- **Stephen Carter** – Performance Program & Managed Services; former UK Minister\\n- **Robert Vrij** – Global Sales & Marketing; ex-CEO of Openwave\\n- **Jeong Kim** – Bell Labs & CSO; ex-Lucent Optical head\\n- **George Nazi** – Global Customer Delivery; ex-BT Global IP/MPLS\\n\\n### Strategic Initiatives Since 2008\\n1. **Lead with Innovation**\\n   - Shifted R&D from legacy to next-gen (75% by 2011)\\n   - Introduced FP3 chipset, 100G optics, lightRadio™, vectoring/bonding\\n\\n2. **Cost Restructuring**\\n   - €1bn fixed cost reduction (2008–2011)\\n   - 17,000 headcount reduction (excl. managed services)\\n\\n3. **Non-Core Asset Monetization**\\n   - €3.5bn in divestitures (2008–2011)\\n\\n### Performance Metrics\\n- Adjusted operating margin improved from -0.4% (2009) to 3.4% (2011)",
      "categories": ["6.1", "7.1"]
    },
    {
      "id": 25,
      "title": "Alcatel-Lucent Operating Segments and Regional Footprint",
      "md": "## VI. Company Overview – Operating Segments and Geographic Reach\\n\\n### Segment Breakdown (LTM Sep-2012)\\n- **Networks (61%)** – Revenue: €8,873m, Profit: €(268)m, Margin: -3.0%\\n- **Software, Services & Solutions (31%)** – Revenue: €4,492m, Profit: €232m, Margin: 5.2%\\n- **Enterprise (5%)** – Revenue: €772m, Profit: €(9)m, Margin: -1.2%\\n- **Other (3%)** – Revenue: €363m, Profit: €(53)m, Margin: -14.9%\\n\\n**Sub-segments:**\\n- IP (13%), Optics (15%), Wireless (23%), Wireline (10%)\\n- Network Applications (3%), Services (28%)\\n\\n### Geographic Revenue Distribution\\n- **North America** – 39%\\n- **Europe** – 27%\\n- **Asia Pacific** – 18%\\n- **Rest of World** – 16%\\n\\n### Global Infrastructure Footprint\\n- Executive Briefing Centers\\n- Research Centres\\n- IP Transformation Centres\\n- Product & Solution Development Centres\\n- Bell Labs\\n\\nAlcatel-Lucent has strong exposure to North America and emerging markets (China, Russia, Latin America), reducing its reliance on Europe.",
      "categories": ["2.1", "5.1", "5.2"]
    },
    {
      "id": 26,
      "title": "Internet Protocol Division – Market and Strategy",
      "md": "## 1) Internet Protocol (Networks)\\n\\n### Market Overview\\n- Total Addressable Market: ~€14bn\\n- CAGR (2011–2015): 9%\\n- Segments:\\n  - IP Edge (incl. CDN): €7bn, +8%\\n  - IP Core: €3bn, +8%\\n  - Mobile Gateway: €2bn, +12%\\n  - Data Centers: €2bn, +15%\\n\\n### Market Share (2011)\\n- Alcatel-Lucent: 11% overall, 23% in edge routers\\n- Cisco: 37%, Ericsson: 33%, Huawei: 13%\\n\\n### Strategy and Products\\n- Focus: IP/MPLS Routing, Mobile Packet Core, CDN, MSWAN\\n- Innovations: FP3 chip, SROS OS, Optical IP integration\\n- Key product: 7950 XRS core router\\n- Clients: Verizon, AT&T, NTT Docomo, Etisalat\\n- Growth: 16% CAGR (2009–2011), strong presence in Americas and Asia\\n- Gross Margin: 50–55%\\n\\n### Differentiators\\n1. Vertically integrated from chipset to services\\n2. Scalable across edge to core\\n3. Optical integration for improved efficiency",
      "categories": ["2.1", "4.1", "3.2"]
    },
    {
      "id": 27,
      "title": "Debt Maturity Profile – Current vs. Pro Forma (Graphical Analysis)",
      "md": "## Debt Maturity Profile – Current vs. Pro Forma\\n\\n### Figure 18: Current Debt Maturity Profile\\n- **Cash & Cash Equivalents:** €4,705 million\\n- **Debt Maturities:**\\n  - 2013: €619 million\\n  - 2014: €462 million\\n  - 2015: €1,075 million\\n  - 2016: €500 million\\n  - 2017: €747 million\\n  - 2020 and Thereafter: €1,156 million\\n\\n### Figure 19: Pro Forma Debt Maturity Profile (Assuming a 6-Year TLB)\\n- **Cash & Cash Equivalents:** €6,255 million\\n- **Debt Maturities:**\\n  - 2013: €12 million\\n  - 2014: €12 million\\n  - 2015: €12 million\\n  - 2016: €899 million (split: €500m + €399m)\\n  - 2017: €747 million\\n  - 2018: €1,174 million\\n  - 2020 and Thereafter: €1,156 million\\n\\n> **Note:** Maturity profiles exclude \\"Other financial debt\\" and reflect maturities as due at reported values per Q3 2012 consolidated financials.\\n\\n**Key Insight:**\\nThe pro forma adjustment significantly smooths the debt maturity profile, reducing near-term maturities and pushing obligations further into the future. This provides enhanced liquidity flexibility to execute the turnaround strategy.",
      "categories": ["8.3", "7.1"],
      "meta": {
        "artefact_type": "Chart",
        "source_page": "Key Credit Highlights 24",
        "related_figures": ["Figure 18", "Figure 19"]
      }
    },
    {
      "id": 28,
      "title": "Alcatel-Lucent Operating Segments Overview",
      "md": "## Figure 20: Overview of Alcatel-Lucent Operating Segments\\n\\n### Consolidated Segment Structure (LTM as of 30-Sep-2012, excl. Genesys)\\n\\n**1. Networks (61% of Revenues)**\\n- **Revenue:** €8,873 million\\n- **Adjusted Profit:** €(268) million\\n- **Margin:** -3.0%\\n- **Sub-segments:**\\n  - **IP (13%)** – Revenue: €1,847m\\n  - **Optics (15%)** – Revenue: €2,234m\\n    - Terrestrial\\n    - Submarine\\n  - **Wireless (23%)** – Revenue: €3,393m\\n  - **Wireline (10%)** – Revenue: €1,440m\\n\\n**2. Software, Services & Solutions (31% of Revenues)**\\n- **Revenue:** €4,492 million\\n- **Adjusted Profit:** €232 million\\n- **Margin:** 5.2%\\n- **Sub-segments:**\\n  - **Network Applications (3%)** – Revenue: €447m\\n  - **Services (28%)** – Revenue: €4,047m\\n    - Professional Services\\n    - Managed Services\\n    - Maintenance Services\\n\\n**3. Enterprise (5% of Revenues)**\\n- **Revenue:** €772 million\\n- **Adjusted Profit:** €(9) million\\n- **Margin:** -1.2%\\n\\n**4. Other (3% of Revenues)**\\n- **Revenue:** €363 million\\n- **Adjusted Profit:** €(53) million\\n- **Margin:** -14.9%\\n\\n> *Note: Segment percentages represent share of total revenues. Figures include inter-segment elimination. Source: Company.*",
      "categories": ["2.1", "5.1", "5.2"],
      "meta": {
        "artefact_type": "Chart",
        "source_page": "Company Overview 26",
        "related_figures": ["Figure 20"]
      }
    },
    {
      "id": 29,
      "title": "Submarine Optics Division – Market and Performance",
      "md": "## Submarine Optics (Networks)\\n\\n### Market Overview\\n- Size: ~€2bn, cyclical in nature\\n- Two sub-segments:\\n  1. Cable, terminal equipment & repeaters – high tech, high barrier to entry\\n  2. Marine installation & maintenance – success depends on vessel ownership and skilled crew\\n- Key customers: international telecom consortia and enterprises responding to traffic growth, especially in Africa, SE Asia, Latin America\\n\\n### Market Share (2011)\\n- Alcatel-Lucent: 43% (market leader)\\n- Tyco/TE: 28%\\n- NEC: 15%\\n- Other: 14%\\n\\n### Strategy and Performance\\n- Fully integrated business (fiber manufacturing to maintenance)\\n- Key wins: Pacific Caribbean, Angola-WACS, Main One\\n- Marine co-venture with Louis Dreyfus Armateurs\\n\\n### Financials\\n- CAGR (2009–2012): -9.7%\\n- Recent wins suggest recovery in 2013–14\\n- Gross margins stable: 29.7% (2009) to 28.6% (LTM Sep-2012)\\n\\n**Figure 31:** Submarine Optics Revenue and Gross Margin (2009–LTM Sep-2012)",
      "categories": ["2.1", "4.1", "7.1"]
    },
    {
      "id": 30,
      "title": "Wireless Division – Market Trends and Strategy",
      "md": "## Wireless (Networks)\\n\\n### Market Overview\\n- Global Market Size: ~€27bn\\n- Flattish growth overall; strong growth in:\\n  - LTE (+55% CAGR 2011–15)\\n  - Small Cells (€0.3bn in 2011 → €5bn by 2016, 93% CAGR)\\n\\n### Market Shares by Segment (2011)\\n- LTE: Alcatel-Lucent 10%, Ericsson 44%\\n- CDMA: Alcatel-Lucent 37%\\n- WCDMA, GSM: lower ALU share vs. Ericsson, Huawei, NSN\\n\\n### Strategy and Products\\n- Portfolio: GSM, CDMA, UMTS/HSPA, LTE, small cells, lightRadio™\\n- Key clients: Verizon, AT&T, Sprint, China Mobile/Telecom/Unicom, Vodafone, Etisalat, Orascom\\n- Strong presence in LTE rollouts (esp. US and Brazil)\\n\\n### Financials\\n- Revenue CAGR (2009–2011): 7.8%\\n- Gross Margin: improved from 42.9% (2009) to 45.6% (2010), declined to 35.2% (LTM Sep-2012) due to lower CDMA volumes\\n\\n**Figure 34:** Wireless Revenue and Gross Margin (2009–LTM Sep-2012)",
      "categories": ["2.1", "3.1", "4.1", "7.1"]
    },
    {
      "id": 31,
      "title": "Wireline Division – Fixed Broadband Market and Strategy",
      "md": "## Wireline (Networks)\\n\\n### Market Overview\\n- Market Size: ~€4.5bn\\n- CAGR (2011–14): 7%\\n- Key segments:\\n  - VDSL: €0.4bn, +18% CAGR\\n  - GPON: €1.4bn, +21% CAGR\\n\\n### Competitive Position\\n- DSL market: Alcatel-Lucent 37% share\\n- GPON OLT: 24%, GPON ONT: 30%\\n- Key customers: AT&T, Verizon, Bell Canada, China Telecom, China Mobile, major European operators\\n\\n### Strategy and Offerings\\n- Copper and fiber access, VDSL2 with vectoring\\n- IP Multimedia Subsystem (IMS)\\n- Fixed broadband as backhaul for small cells\\n- Strong presence in fiber-rich regions (e.g., China, Europe)\\n\\n### Market Drivers\\n- Growth in data traffic and demand for high-bandwidth services\\n- European Telcos expanding FTTC/VDSL and FTTH infrastructure\\n- Vectoring technology enables higher speeds via copper\\n\\n**Figures:**\\n- Figure 35: Global Wireline Market Forecast (2011–14)\\n- Table 1: European VDSL/FTTH Expansion Plans\\n- Figure 36: Incumbent Telco Fiber Build (2012)\\n- Figure 37: VDSL Speed Comparison\\n- Figure 38: Market Share by Subsegment",
      "categories": ["2.1", "3.1", "4.1", "7.1"]
    },
    {
      "id": 32,
      "title": "European Incumbent Fiber Deployment by Country – Mid 2012",
      "md": "## Figure 36: Incumbent Telco Fiber Build at Mid 2012\\n\\nThis figure compares the fiber deployment levels of incumbent telecom operators across European countries as of mid-2012. Deployment is split between:\\n- **FTTCab (Fiber to the Cabinet)** – darker bars\\n- **FTTH (Fiber to the Home)** – lighter bars\\n\\n### Leading Countries by Total Fiber Deployment:\\n- **Switzerland** – Near 100% coverage (dominantly FTTCab, some FTTH)\\n- **Belgium** – Over 80% (mostly FTTCab)\\n- **Finland** – ~75% (mix of FTTCab and FTTH)\\n- **UK, Portugal, Germany** – All above 50% with significant FTTCab builds\\n\\n### Countries with Moderate to Low Deployment:\\n- **Denmark, Sweden, Netherlands** – Between 30% to 50%\\n- **France, Norway, Spain, Italy, Austria** – 10–30%\\n- **Trailing countries (e.g. Norway and France at the bottom)** – Under 10%\\n\\n> Source: Industry Analyst\\n\\n**Insight:** Alcatel-Lucent stands to benefit from this market expansion, particularly in countries rapidly scaling FTTC and FTTH infrastructure where its VDSL and GPON technologies align closely with operator strategies.",
      "categories": ["3.1", "4.1", "7.1"],
      "meta": {
        "artefact_type": "Chart",
        "source_page": "Company Overview 38",
        "related_figures": ["Figure 36"]
      }
    },
    {
      "id": 33,
      "title": "Wireline Strategy and Performance",
      "md": "## Alcatel-Lucent Strategy and Performance – Wireline\\n\\nThe Company’s family of IP-based fixed access products provides support for both copper and fiber- and copper-based broadband access to the customer’s premise or to use them in highly optimized combinations. The IP Multimedia Subsystem (IMS) activities are focused on the delivery of session and media gateway control. Another key area of focus is VDSL2, offering vectoring capabilities to increase bandwidth that can be delivered over existing copper infrastructure.\\n\\nDespite a trend towards commoditization, Alcatel-Lucent has been able to compete effectively due to operational excellence and technological superiority. This translates into #1 and #2 positions in the wireline broadband market respectively in DSL and GPON.\\n\\nThis is evidenced by the key customer relationships in the wireline divisions with market leaders such as AT&T, Verizon, Bell Canada in the Americas, China Telecom, China Unicom, China Mobile in Asia-Pacific and all the major tier one operators in Europe. Recently, China, with significant fiber access equipment uptake, and Europe, with renewed interest in DSL through VDSL2 vectoring solutions, have been key drivers of success.\\n\\nThe Wireline business has decreased by high single digits between 2009 and 2011, driven by the decline of legacy technologies (TDM, ATM DSL), only partially offset by progressive broadband access growth. Since 2009, instead of expanding wireline capacity, service providers have instead focused on wireless spending (in the US), and are under capex constraints in Europe given weak cashflow generation and pressure to deleverage.\\n\\nAlcatel-Lucent’s next generation Wireline product portfolio (IPDSLAM, fiber-based access products) grew from 45% in 2009 to 77% in 2012. This explains why 2012 LTM returned to growth as new technology now accounts for the majority of the activity in the division.\\n\\nThe broadband access growth has been driven by the expansion of fiber, especially PON in Asia Pacific (recent quarters growing in excess of 75%), and more recently by the revitalization of copper thanks to major innovations (VDSL bonding and vectoring that are now used in large trials, especially in Europe for instance by Belgacom).\\n\\nWireline Gross Margin was resilient over the period, as the positive impact of new technology compensated the impact of lower volumes in legacy.\\n\\n**Figure 39: Key Historical Financials – Wireline (€m)**\\n- Revenue (2009–LTM Sep-2012): 1,618 → 1,440\\n- Gross Margin: 23.3% → 22.4%\\n\\nIn the medium term, Management remains optimistic about the Wireline division. Increasing fixed networks broadband availability remains a key objective of governments worldwide. As mobile data growth expands rapidly, fixed networks become critical for backhaul and small cells. Lastly, there are increasing opportunities to integrate GPON with IP/Optics products as evidenced by recent announcement made by AT&T and Deutsche Telekom.",
      "categories": ["2.1", "4.1", "7.1"]
    },
    {
      "id": 34,
      "title": "Network Applications – Market and Strategy",
      "md": "## Network Applications (Software, Services & Solutions)\\n\\n### Market Overview\\nThe Network Applications refer to activities related to the development and sale of solutions that combine software, services and partnerships to address key telecommunication service provider market opportunities. As such, network applications address a c. €9bn market enjoying fast growth (17%), in several sub-segments:\\n- Control (IMS, Payment, Messaging): €5bn, 15% growth\\n- Decision analytics (Mobile Commerce, CxT): €2bn, 21% growth\\n- Exposure (Application enablement): €1bn, 39% growth\\n- Telco cloud (emerging business)\\n\\n**Figure 40: Network Applications Market (€bn)**\\n- Total CAGR 2011–2014: 17%\\n\\nCustomers are primarily telecommunication service providers. They require support related to efficient and scalable service creation and delivery platforms (e.g. IMS VoLTE), the take up of mobile data services, tiered pricing for different business service level packages, cloud solutions enabling new services to enterprises as well as analytics and experience optimization.\\n\\n**Figure 41: Network Applications Market Shares (2011)**\\n- NSN: 8%, Ericsson: 7%, Oracle: 7%, Alcatel-Lucent: 7%, Comverse: 6%, Huawei: 5%, Other: 61%\\n\\n### Strategy and Performance\\nAlcatel-Lucent’s Network Applications combine software, services and network hardware to address key customer challenges and opportunities in the areas of advanced communications, mobile commerce, payment and charging, customer experience and application enablement.\\n\\nAlcatel-Lucent’s competitive strengths relate to key control, optimization and analytics experience enablers over all-IP networks. These are highly strategic for operators as they permit experience creation and new services on-boarding. Moreover, there are several important Alcatel-Lucent innovations in the field such as Cloudband, customer experience solutions/motive, as well as best-in-class assets (Policy, IMS).\\n\\nAlcatel-Lucent works with most of the world’s leading telecommunication service providers. Its clients cover a diversified portfolio along Alcatel-Lucent’s network positions: Verizon, AT&T, Saudi Telecom, Vodafone, Sprint, China Mobile, China Telecom, France Telecom, Globacom, China Unicom.\\n\\nNetwork Applications decreased at a mid-single digit throughout the period 2009-2011. Its decline accelerated in LTM due to the termination in Q4 2011 of a resale activity.\\n\\nThe Network Applications Gross Margin to Q3 2012 was driven in by decline of legacy technologies.\\n\\n**Figure 42: Key Historical Financials – Network Applications (€m)**\\n- Revenue (2009–LTM Sep-2012): 567 → 447\\n- Gross Margin: 45.8% → 40.9%\\n\\nLooking forward, Management sees significant opportunities in Cloudband, analytics for customer experience (Motive), smart charging (bundled with DSC/policy) as well as mobile Commerce (Optism). Furthermore, management anticipates that as IMS control grows with VoLTE, there could be potential upside in IMS applications.",
      "categories": ["2.1", "4.1", "7.1"]
    },
    {
      "id": 35,
      "title": "Professional and Managed Services – Strategy and Performance",
      "md": "## Professional Services (Software, Services & Solutions)\\n\\n### Market Overview\\n- Professional network integration: €17bn, >5% growth\\n- Consulting services: €1.5bn, >5% growth\\n\\nKey customers include telecom service providers and verticals. Alcatel-Lucent supports LTE deployment, cloud model adoption, video technology integration, customer experience transformation, and cost optimization.\\n\\n**Figure 43: Services Market Share (2011)**\\n- Ericsson: 11%, NSN: 8%, Alcatel-Lucent: 7%, IBM: 4%, Huawei: 4%, Other: 66%\\n\\n### Strategy and Performance\\nAlcatel-Lucent is a world leader in supplying services for telecommunications and strategic industries. It offers services to transform networks to next-generation wireless and converged all-IP platforms.\\n\\nAbout half of Professional Services revenue comes from strategic industries. Key wins include:\\n- BDBOS Security Forces (Germany)\\n- Switzerland Railways (transportation)\\n- Oil & gas contracts in Australia\\n\\n## Managed Services (Software, Services & Solutions)\\n\\n### Market Overview\\n- High customer value outsourcing: €1bn, 18% growth\\n- Network outsourcing and maintenance: €9bn, 12% growth\\n- NOC Services: €1bn, 12% growth\\n\\n**Figure 44: Managed Services Market Share (2011)**\\n- Ericsson: 32%, NSN: 22%, Alcatel-Lucent: 17%, Other: 29%\\n\\n### Strategy and Performance\\nThe Managed Services practice simplifies network transformations, reduces solution introduction risks, and cuts operating expenses.\\n\\nLooking forward, Management intends to restructure or exit 15 underperforming Managed Services contracts.\\n\\n## Combined Financials: Professional and Managed Services\\n\\n**Figure 45: Key Historical Financials – Services (€m)**\\n- Revenue (2009–LTM Sep-2012): 3,781 → 4,047\\n- Gross Margin: 23.1% → 22.1%\\n\\nGrowth drivers include:\\n- LTE, optics, and IP roll-outs\\n- Strategic industries (oil & gas, transport, public sector)\\n\\nManagement sees further upside in Services from customer experience and IMS-based platforms.",
      "categories": ["2.1", "4.1", "7.1"]
    },
    {
      "id": 36,
      "title": "Enterprise Segment – Market Overview and Strategy",
      "md": "## Enterprise\\n\\n### Market Overview\\nThe Enterprise segment delivers solutions to improve conversations across employees, customers and partners by driving multi-media, multi-device, multi-party communications and collaboration.\\n\\nThe Enterprise market represents a €31bn opportunity (3% growth) including three sub-segments:\\n1) Telephony and Applications (“Voice”) (€9bn in 2012)\\n  - TDM Telephony (€3bn)\\n  - IP/Hybrid Telephony (€6bn)\\n2) Data Infrastructure (€19bn)\\n  - LAN Switch L2/L3 (€14bn)\\n  - WLAN (€3bn)\\n  - Enterprise Routers (€2bn)\\n3) VPN IPSEC/SSL (“Security”) (€4bn)\\n\\n**Figure 46: Enterprise Market (€bn)**\\n- CAGR 2011–2014: Total +3%\\n- IP/Hybrid Telephony: +9%\\n- WLAN: +17%\\n- VPN IPSEC/SSL: +8%\\n- TDM Telephony: -3%\\n- Router (Enterprise): +1%\\n- LAN Switch L2/L3: -10%\\n\\nThe main customers in this market are medium and large enterprises based on a largely indirect revenue model. The primary focus is in Western Europe. Customers are looking for means of improving user experience leveraging apps and mobile devices in the voice segment as well as high performance, low-cost, scalable solutions in the data segment.\\n\\nThe main players competing with Alcatel-Lucent in this market are Cisco, Avaya, Siemens, Juniper and Checkpoint.",
      "categories": ["2.1", "4.1", "3.1"]
    },
    {
      "id": 37,
      "title": "Enterprise Strategy and Performance",
      "md": "## Alcatel-Lucent Strategy and Performance – Enterprise\\n\\nAlcatel-Lucent offers unified communication and collaboration applications, i.e. fixed and mobile unified communications software and products that integrate communications networks with in-house data, systems and business process platforms to provide anytime, anywhere access to business data across the enterprise. It also offers communications platforms and telephony solutions, i.e., next generation enterprise communications that deliver multimedia, multi-device, multi-party communication to enterprise employees across site and locations. Lastly, the Company has comprehensive project management and professional services in its portfolio; these are offerings for large enterprises, carriers and customers in a wide range of vertical markets.\\n\\nAlcatel-Lucent benefits from several distinct competitive strengths. It is a leading player in Western Europe with a large installed base and fast growing data switches portfolio; it offers a low-cost alternative to Cisco/Avaya and has a strong presence in key verticals including telecommunications, government, healthcare, education, transportation, energy and utilities.\\n\\nKey customers in this segment include NextiraOne, Orange, Alliance-Com, Deutsche Telecom, MGCE.\\n\\nThe Enterprise business has been resilient over the period 2009-2011 but declined LTM Q3 2012 due to the uncertain economic environment in Europe, where most of Enterprise business is located. Nonetheless, there was good traction in data networking, with mid to high single digit growth, due to a renewed portfolio such as Omniswitch 10k, Omniswitch 6900 for data centers.\\n\\nGenesys is excluded from the below figures, a business that was sold at the beginning of 2012.\\n\\nGross Margins have been fairly stable over the period as productivity gains and a new portfolio have compensated lower volumes.\\n\\n**Figure 47: Key Historical Financials – Enterprise (excluding Genesys) (€m)**\\n- Revenue: 823 (2009), 847 (2010), 822 (2011), 772 (LTM Sep-2012)\\n- Gross Margin: 43.5%, 44.0%, 46.1%, 46.0%\\n\\nLooking forward, Management sees significant opportunities in the transformation to IP/SIP and personal cloud models, increased demand in the data centers as well as growth in emerging markets.",
      "categories": ["2.1", "4.1", "7.1"]
    },
    {
      "id": 38,
      "title": "Research & Development and Patent Strategy",
      "md": "## Research & Development\\n\\nAlcatel-Lucent places a priority on research and development because innovation creates technologies and products that can differentiate the Company from its competitors and can potentially generate new sources of revenue. Research is undertaken by Bell Labs, Alcatel-Lucent’s world-renown research arm. In addition to the new products and technologies brought to market, in 2011 and 2012 the Company’s R&D community and Bell Labs continued to achieve advances across a wide range of disciplines – from optical networking to eco-sustainable (“green”) technologies, to wireline and wireless technologies. The following are examples of some of ongoing projects:\\n\\n- In 2011, Alcatel-Lucent introduced a new network processor that delivers a fourfold increase in performance over the fastest Internet Protocol (IP) networks available today. By supporting 400 Gbps transmission speeds, the FP3 processor opens up new possibilities for bandwidth-intensive services, applications and content, while cutting power consumption by up to 50%.\\n- Alcatel-Lucent’s lightRadio™ product made its debut at Mobile World Congress in February 2011. The cube sized device represents a new approach where a base station (typically located at the base of each cell site tower) is broken into its antenna and a cloud-like network. Since its launch, the lightRadio™ team has made tremendous strides, including connecting the world’s first long-distance, high-quality mobile video-call using lightRadio™. The lightRadio™ team is building collaborative partnerships with several large carriers, including China Mobile and Telefonica. It also has won several industry awards, including the CTIA E-Tech Award, Light Reading’s Best New Product in the Mobile category, and the Broadband World Forum Infovision Award.\\n- In Dec-2011, Alcatel-Lucent made a major advance in 100Gbps optical networking by introducing a breakthrough in single-carrier coherent technology that will extend optical signals over distances far greater than has been possible before, even over poor quality fiber. 400G Photonic Service Engine (PSE) is the first-ever commercially available electro-optics chip capable of driving traffic up to 400 gigabits per second (Gb/s). Versatile and scalable, it dramatically boosts the performance of 100G networks today and lays the foundation for 400G transport down the road.\\n- Alcatel-Lucent is a world leader in VDSL and has made numerous breakthrough inventions in the field. VDSL2 took copper to higher speeds. Now, the world’s first commercial VDSL2 vectoring technology turbo charges broadband on copper to 100 Mbps and beyond.\\n\\nAs a result of this research – with a cumulative R&D spend of $55bn by Alcatel-Lucent and Lucent in the last 15 years – the Company benefits from a large and valuable patent portfolio, with c. 45k total patent assets, including c. 30k granted patents (average remaining life of 9 years) and c. 15k pending applications (average remaining life of 16 years).\\n\\nManagement believes a more aggressive patent monetization approach could bring profits from patents in line to those of key peers. To that end, the Company has entered into an agreement with patent licensing company RPX, then decided to manage its patent portfolio with a dedicated profit center and appointed Craig Thompson (formerly of Nokia, instrumental in facilitating the significant increase in patent monetization 2010-2011) in Nov-2012 to lead a new business unit managing the intellectual property portfolio.",
      "categories": ["2.1", "4.1", "7.1"]
    },
    {
      "id": 39,
      "title": "Group Cash Management and Liquidity",
      "md": "## Group Cash Management and Liquidity\\n\\nParent, Borrower and their subsidiaries utilize a centralized cash management system, pursuant to which funds generated from their respective operations are swept daily to one or more bank master accounts held by Parent. The funds in these accounts are disbursed from time to time to fund the working capital and other financing needs of Parent’s direct and indirect subsidiaries. Parent and Borrower maintain accounting records that reflect these intercompany transfers as part of their debt/cash position.\\n\\nUpon the closing of the Loans, it is expected that Borrower will transfer the proceeds of the Loans (the “Loan Proceeds”) into one or more of Parent’s bank accounts that are part of this cash management system, and as a result Borrower will have an unsecured intercompany debt claim against Parent for such amounts. Such Loan Proceeds, together with the existing funds in this cash management system, are expected to be used from time to time for the respective working capital needs of Parent, the Borrower and/or their subsidiaries, including the repayment of certain outstanding indebtedness of Parent, Borrower and/or other subsidiaries that is maturing in the near-term. Borrower is not liable, either as a primary obligor or a guarantor, on certain of such indebtedness that may be repaid from liquidity in the cash management system.\\n\\nWhile we have no reason to believe (x) that Alcatel-Lucent USA (“Borrower”) is or, upon closing of the Loans, will be, rendered insolvent or (y) that Borrower will not receive reasonably equivalent value in connection with its use of the Loan Proceeds, if we are mistaken and both of clauses (x) and (y) are the case, then the furnishing of the Loans to Borrower and Borrower’s use of the proceeds of the Loans could be challenged as fraudulent transfers under federal and state law, and remedies may be sought (either within or outside of a bankruptcy filing), which could include (i) the unwinding of those transfers, and/or the termination of the Lenders’ liens or (ii) repayment of the portion of the transferred Loan Proceeds found to be a fraudulent conveyance.\\n\\nIn late November 2012, the board of Alcatel-Lucent USA received correspondence from a purported holder of Alcatel-Lucent USA debentures and trust preferred securities asserting that Alcatel-Lucent USA was insolvent or near insolvent and further asserting that certain intercompany loans extended from time to time to its parent Alcatel Lucent constitute fraudulent transfers and/or illegal dividends. In light of Alcatel-Lucent USA’s solvency, which will be certified to by an officer of the Borrower in connection with the closing of the financing, Alcatel-Lucent USA believes the allegations made lack any merit.",
      "categories": ["7.1", "8.1", "10.1"]
    },
    {
      "id": 40,
      "title": "Corporate Repositioning and the Performance Program",
      "md": "## VII. Corporate Repositioning and the Performance Program\\n\\nIn response to the deteriorating macro environment, the deep technological changes and the slowing down of European service providers’ LTE roll-out strategy, the Company decided in the summer of 2012 to re-focus its strategy and initiate a significant cost saving exercise in order to transform/restructure the appropriate organization to support the refined strategy.\\n\\nThe strategic pillars of the refocused Alcatel-Lucent are:\\n1) Take advantage of long term trends in the carrier network infrastructure market, especially in IP and Optical\\n2) Leverage leadership position in IP, Optical and VDSL/FTTX Fixed Broadband Access to enable all-IP infrastructure\\n3) Capitalize on disruptive innovations at Bell Labs\\n4) Implement a profit run approach towards a unique patent portfolio\\n5) Adapt cost base to new environment and exiting/restructuring unprofitable geographies/markets\\n\\nIn line with this strategic vision, on July 26 2012, Alcatel-Lucent announced a restructuring Performance Program which represents a significant forward step in the company’s transformation. The program targets €1.25bn costs savings by year-end 2013, with €500m and €750m realized in 2012 and 2013, respectively.\\n\\nSpecifically, there are four components of the Program:\\n1) Additional global headcount reduction of around 5,500 people\\n2) Exiting or restructuring 15 unprofitable managed services contracts with associated headcount reduction (5 to be exited by year end)\\n3) Exiting or restructuring of unprofitable markets\\n4) Managing patent portfolio as an independent profit center\\n\\nAs a result of the refined strategy and these combined restructuring measures, the Company is targeting Gross Margins of around 35-37% and adjusted operating margins of 6-9% by 2015.",
      "categories": ["6.3", "7.4", "8.4"]
    },
    {
      "id": 41,
      "title": "Cost Reduction Strategy under the Performance Program",
      "md": "## 1) Focus on Costs\\n\\nThe Company’s strategy for eliminating costs is based on reduced staff in back office functions, substantial reductions in Corporate Executive positions and an acceleration of the real estate footprint reduction.\\n\\nThe Company targets a cost reduction of €1.25bn by year-end 2013 of which €500m has been announced in November 2011 and €750m in July 2012. As of September 2012, 35% of the overall objective and 90% of the 2012 target had been achieved. Currently, the Company is on track to over-achieve its full year 2012 target which is respectively €300m and €200m of variable and fixed costs reduction.\\n\\n- On the fixed costs side, more than €300m of reductions have been achieved, mainly in SG&A, IS/IT and Real Estate\\n- On the variable costs side, c.€150m of reductions have been achieved through third parties renegotiations/consolidation and process improvement\\n\\nAlcatel-Lucent aims at reducing its workforce by c. 5,500 by 2013 (excluding Managed Services contracts under review) in order to align the Company’s structure with its smaller, refocused scale. The reductions are likely to be focused on Europe (c.60%), on specific functions and excludes contractors. Support and back offices functions are a major area of reduction with c.60% of the cuts targeted at the SG&A level. Substantial reductions will also take place at the corporate executive level (c.30%). The exit from several Managed Services contracts, which currently have associated headcount of 14,000 in total, could result in further reductions.\\n\\nImportantly, and in line with the Company’s ongoing commitment to innovation, R&D functions will be exempt from this workforce reduction under the ongoing Performance Program in 2012 and 2013.\\n\\nThe Company is in process of undergoing the relevant consultations with labor representatives.\\n\\n**Figure 48: Reductions by Region**\\n**Figure 49: Reduction by Function**",
      "categories": ["6.3", "7.4"]
    },
    {
      "id": 42,
      "title": "Performance Program Focus: Contracts, Geographies, Assets",
      "md": "## 2) Focus on Contracts\\n\\nAlcatel-Lucent plans to exit/restructure unprofitable Managed Services contracts – the contracts that are being reviewed have a negative impact on overall Group Gross Margin. Thus, their exit/restructuring should significantly improve Group margins going forward. In the past, the Company entered into a number of contracts with telecommunication providers to service their network operations, the terms of which result in unprofitable levels.\\n\\nManagement has identified 15 managed services contracts, representing c.€600m in revenue, out of a total 68 contracts, representing c.€1bn in revenue, that are materially below the corporate average profit margin. To address these, the Company is engaging in constructive negotiations with the affected telecom operators. The current plan is to exit or restructure five contracts by year-end 2012, with the remainder to be addressed by the end of 2013.\\n\\nAlthough the program is expected to lead to a top-line reduction over the next 24 months in Managed Services, profitability is expected to improve starting in Q1 2013 as a result.\\n\\n## 3) Focus on Geographies\\n\\nAlcatel-Lucent aims to improve its geographical mix and exit/restructure unprofitable markets. To that end, the Company has re-evaluated its coverage strategy in order to simplify its operating model. The Company has sales activity in 180 countries. Yet, the top 60 countries represent 96% of revenues. To rectify this imbalance, the Company intends to adapt its go-to-market strategy whereby it would address c.45 markets through sales channels only (indirect sales to all customers in the country), and 15 countries through exports only (simplified operating model, direct sales to customers, no permanent headcount in the country).\\n\\nThis re-alignment is expected to result in a reduction of the complexity for pre-sales, order management and networks roll-out and thus should ultimately have a positive impact on capital employed.\\n\\nOverall, the Company intends to focus on some markets, most notably the U.S., Asia-Pacific and selected geographies such as Latin America or Middle-East.\\n\\n## 4) Focus on Assets\\n\\nAlcatel-Lucent aims to improve the way it monetizes its significant pool of assets.\\n\\nGoing forward, Alcatel-Lucent’s patent portfolio will therefore be managed as an independent profit centre. Moreover, a new Head of Intellectual Property business has been named who has significant experience increasing the royalty income from telecommunication patent portfolios. Also, the RPX patent agreement announced earlier in 2012 has been modified to remove exclusivity and the company has actively engaged with third parties that might be infringing on its patents in order to increase royalty collection.\\n\\nLastly, to improve the liquidity profile of the group, Management is also considering the divestiture of non-core assets. The Company is currently evaluating options for the divesture of several distinct businesses with expected sale proceeds of €1.0-1.5bn.",
      "categories": ["6.3", "8.4", "10.1"]
    },
    {
      "id": 43,
      "title": "Q3 2012 Consolidated Financial Performance",
      "md": "## 2) Current Trading September 2012\\n\\nThe table below summarizes Alcatel-Lucent’s financial performance on a consolidated basis for Q3 2012, comparing it to Q3 2011 and Q2 2012.\\n\\n**Table 6: Quarterly Historical Income Statement**\\n\\n| (€m)                   | Q3 2011 | Q2 2012 | Q3 2012 | YoY Change |\\n|------------------------|---------|---------|---------|------------|\\n| IP                    | 376     | 473     | 490     | 30.3%      |\\n| Optics                | 582     | 542     | 480     | (17.5)%    |\\n| Wireless              | 1,032   | 877     | 837     | (18.9)%    |\\n| Wireline              | 308     | 350     | 389     | 26.3%      |\\n| Other & eliminations  | (13)    | (12)    | (8)     | n.s.       |\\n| **Total Networks**         | 2,285   | 2,230   | 2,187   | (4.3)%     |\\n| Services              | 996     | 959     | 1,058   | 6.2%       |\\n| Network Applications  | 104     | 94      | 97      | (6.7)%     |\\n| Other & eliminations  | -       | (1)     | -       | n.s.       |\\n| **Total Software, Services & Solutions** | 1,100   | 1,053   | 1,155   | 5.0%       |\\n| Enterprise            | 218     | 191     | 188     | (13.8)%    |\\n| Other                 | 101     | 71      | 69      | n.s.       |\\n| **Revenues**               | 3,704   | 3,545   | 3,599   | (2.8)%     |\\n| **Gross Margin**           | 1,308   | 1,125   | 1,004   | (23.2)%    |\\n| % margin              | 35.3%   | 31.7%   | 27.9%   | (7.4)pt    |\\n| SG&A                  | (606)   | (580)   | (543)   | (10.4)%    |\\n| R&D Net               | (553)   | (576)   | (586)   | 6.0%       |\\n| **Adjusted operating income¹**  | 149     | (31)    | (125)   | N/M        |\\n| % margin              | 4.0%    | (0.9)%  | (3.5)%  | 7.5pt      |\\n| **Adjusted EBITDA²**         | 356     | 186     | 114     | (47.9)%    |\\n| % margin              | 9.6%    | 5.2%    | 3.2%    |            |\\n\\n**Table 7: Quarterly Historical Revenues by Region**\\n\\n| (€m)            | Q3 2011 | Q2 2012 | Q3 2012 | YoY Change |\\n|----------------|---------|---------|---------|------------|\\n| North America  | 1,431   | 1,397   | 1,459   | 1.9%       |\\n| Asia Pacific   | 691     | 620     | 680     | (1.6)%     |\\n| Europe         | 1,056   | 944     | 893     | (15.6)%    |\\n| RoW            | 526     | 584     | 567     | 8.4%       |\\n| **Revenues**        | 3,704   | 3,545   | 3,599   | (2.8)%     |\\n\\nSource: Company\\n\\nNote: Figures are presented with Genesys business in discontinued operations for all periods in order to provide meaningful comparable information.\\n\\n¹ Adjusted for PPA impact.  \\n² “Adjusted EBITDA” defined as operating income adjusted for PPA + depreciation and amortization + share base payment.",
      "categories": ["7.1", "7.2"],
      "meta": {
        "artefact_type": "table + analysis",
        "document_section": "Historical Financial Overview",
        "page_number": 55,
        "relevant_entities": ["Alcatel-Lucent"]
      }
    },
    {
      "id": 44,
      "title": "Q3 2012 Quarterly Cash Flow and Balance Sheet",
      "md": "### Table 8: Historical Cash Flow Statement (Quarterly)\\n\\n| (€m)                         | Q3 2011 | Q2 2012 | Q3 2012 |\\n|------------------------------|---------|---------|---------|\\n| Adjusted operating income¹  | 149     | (31)    | (125)   |\\n| % margin                    | 4.0%    | (0.9)%  | (3.5)%  |\\n| Depreciation & Amortization²| 207     | 217     | 239     |\\n| **Adjusted EBITDA**              | 356     |         | 114     |\\n| Change in operating WCR     | (274)   | (182)   | 14      |\\n| Change in other WCR         | (46)    | (188)   | (121)   |\\n| **Operating cash flow**          | 36      | (184)   | 7       |\\n| Interest                    | (105)   | (24)    | (88)    |\\n| Taxes                       | (8)     | (38)    | (12)    |\\n| Cash contribution to pension & OPEB | (45) | (55)    | (31)    |\\n| Restructuring cash outlays | (99)    | (80)    | (93)    |\\n| **Cash flow from operating activities** | (221)   | (381)   | 186     | (217)   |\\n| Capital expenditures        | (137)   | (130)   | (143)   |\\n| % Revenues                 | (3.7)%  | (3.7)%  | (4.0)%  |\\n| **Free cash flow**               | (358)   | (511)   | (360)   |\\n\\nSource: Company information\\n\\n---\\n\\nThe Company carefully manages its balance sheet. It seeks to hold a material liquidity buffer, in part to compensate for c €1.1bn of cash restricted, mainly in China. Alcatel-Lucent also proactively hedges its risk, in particular foreign exchange.\\n\\nThe Company ended Q3 2012 with €4.7bn in cash and cash equivalents. As such, the Company’s liquidity buffer remains substantial.\\n\\nNote: Figures are presented with Genesys business in discontinued operations for all periods in order to provide meaningful comparable information.\\n\\n¹ Adjusted for PPA impact.  \\n² Including non cash items in adjusted OP.\\n\\n### Table 9: Historical Balance Sheet (Quarterly)\\n\\n| (€m)                            | Q3 2011 | Q2 2012 | Q3 2012 |\\n|--------------------------------|---------|---------|---------|\\n| Gross cash incl. marketable sec.¹ | 3,757   | 5,009   | 4,705   |\\n| Gross financial debt           | (4,498) | (4,856) | (4,778) |\\n| Derivative interest rate instruments | 35    | 31      | 33      |\\n| Loan to joint venturer         | 19      | 10      | 9       |\\n| Derivative FX instruments      | 67      | 42      | (53)    |\\n| **Net cash / (Net financial debt)**   | (620)   | 236     | (84)    |\\n\\nSource: Company",
      "categories": ["7.1", "7.2", "7.4"],
      "meta": {
        "artefact_type": "table + commentary",
        "document_section": "Historical Financial Overview",
        "page_number": 56,
        "relevant_entities": ["Alcatel-Lucent"]
      }
    },
    {
      "id": 45,
      "title": "Funded Status of Alcatel-Lucent Pensions and OPEB",
      "md": "## 4) Funded Status of Alcatel-Lucent Pensions and OPEB\\n\\nAlcatel-Lucent has significant pension as well as other post employment benefit obligations (OPEBs). Most of these are in the United States and Europe. Significantly over-funded U.S. pension plans permit, in part, the use of assets to fund OPEBs.\\n\\nIn recent years, most cash contributions have been to European pension plans. Most pension plan funding arrangements are multi-year (with variation by jurisdiction), offering the Company a relatively high degree of visibility on future outlays. The Company anticipates global pension and OPEB cash outlays of c. €200m p.a. going forward in line with the historical trend.\\n\\n| (€m)                  | 30-Sep-2011     | 30-Jun-2012     | 30-Sep-2012     |\\n|----------------------|------------------|------------------|------------------|\\n| Pensions             | OPEB            | Pensions         | OPEB            | Pensions         | OPEB            |\\n| Fair value of plan assets | 27,588      | 325              | 29,734          | 396              | 29,618          | 340              |\\n| Benefit obligations   | (25,844)        | (3,282)          | (28,746)        | (3,561)          | (28,459)        | (3,460)          |\\n| Funded Status         | 1,744           | (2,957)          | 988             | (3,165)          | 1,159           | (3,120)          |\\n| Funded status         | (1,213)         |                  | (2,177)         |                  | (1,961)         |                  |\\n| Asset Ceiling         | (1,803)         | -                | (1,277)         | -                | (965)           | -                |\\n| Net balance sheet     | (3,016)         |                  | (3,454)         |                  | (2,926)         |                  |\\n\\nSource: Company\\n\\nNo contributions to US plans will be expected through at least 2016.",
      "categories": ["7.1"],
      "meta": {
        "artefact_type": "table + commentary",
        "document_section": "Historical Financial Overview",
        "page_number": 62,
        "relevant_entities": ["Alcatel-Lucent"]
      }
    },
    {
      "id": 46,
      "title": "Illustrative Re-Allocation of Maintenance P&L and Medium-Term Outlook",
      "md": "## 5) Illustrative Re-Allocation of Maintenance P&L\\n\\nAlcatel-Lucent generates significant revenues and income from the provision of maintenance services associated with particular products. These P&L items are currently reported as part of the Services segment. In order to illustrate the P&L driven by different business lines, the maintenance P&L has been illustratively re-allocated as per the below method.\\n\\n**Figure 58: Illustrative Reporting Structure After Re-Allocation of Maintenance**\\n\\n**Current Reporting**\\n- Networks\\n  - IP\\n  - Optics (incl. Optics Terrestrial)\\n  - Wireless\\n  - Wireline\\n- Software Services & Solutions\\n  - Services (Professional and Managed, incl. Maintenance)\\n  - Networks Applications\\n- Enterprise\\n- Other & Eliminations\\n\\n**Potential Future Reporting**\\n- Networks & Platforms\\n  - IP\\n  - Optics Terrestrial (incl. Maintenance)\\n  - Wireless (incl. Maintenance)\\n  - Fixed Networks (incl. Maintenance)\\n  - Platforms (incl. Maintenance)\\n- Focused Businesses\\n  - Enterprise\\n  - Submarine\\n- Other & Eliminations (incl. Managed Services)\\n\\nProfessional services revenues relating to wireless to be allocated to the Wireless subdivision.\\n\\n**Table 10: Illustrative Re-Allocation of Maintenance P&L** (Extract)\\n\\n|                       | Before Maintenance Re-Allocation (€m) | LTM Q3'12 | After Maintenance Re-Allocation (€m) | LTM Q3'12 |\\n|-----------------------|----------------------------------------|-----------|----------------------------------------|-----------|\\n| Total Revenue         | 15,327                                | 14,500    | 15,327                                | 14,500    |\\n| Networks              | 9,654                                 | 8,873     | Networks & Platforms                   | 12,535    | 11,873    |\\n| S3G                   | 4,461                                 | 4,492     | Non Product Attached Services          | 1,393     | 1,412     |\\n| Networks Applications | 498                                   | 447       | Platforms (incl. Maintenance)          | 668       | 628       |\\n| Enterprise            | 822                                   | 772       | Enterprise                             | 822       | 772       |\\n| Gross Margin          | 5,360                                 | 4,528     | Gross Margin                           | 5,360     | 4,528     |\\n| Adjusted Operating Profit | 519                                | (98)      | Adjusted Operating Profit              | 519       | (98)      |\\n\\nThis re-allocation does not affect consolidated financials at the Group level. A final decision on the change is pending.\\n\\n---\\n\\n## 6) Medium Term Outlook\\n\\nUntil 2015, the Company expects flattish top line growth but a significant improvement in Gross Margins as well as operating profits and EBITDA, which should result in positive cashflow generation.\\n\\n**Table 11: Summary Medium Term Financial Outlook**\\n\\n| Growth        | €bn      | LTM Q3 2012 | 2015E | CAGR (%) | Delta (€bn) |\\n|---------------|----------|-------------|--------|-----------|--------------|\\n| Revenue       |          | 14.5        | 15.2   | 1.5%      | 0.7          |\\n| Gross Margin  |          | 4.5         | 5.5    | 6.4%      | 1.0          |\\n| % revenue     |          | 31%         | 35–37% |           |              |\\n| SG&A          |          | (2.3)       | (1.9)  | (5.7)%    | 0.4          |\\n| R&D           |          | (2.3)       | (2.2)  | (1.4)%    | 0.1          |\\n| Adj. Op. Profit |        | (0.1)       | 1.3    | n.m.      | 1.4          |\\n| Adj. EBITDA   |          | 0.7         | 2.1    | 40.2%     | 1.4          |\\n\\n**Table 12: Revenue Outlook – LTM Q3 2012 to 2015E**\\n\\n| Division     | LTM Q3 2012 | 2015E | CAGR (%) |\\n|--------------|-------------|--------|-----------|\\n| Total Revenue| 14.5        | 15.2   | 1.5%      |\\n| Networks     | 8.9         | 10.0   | 4.2%      |\\n| IP           | 1.8         | 2.9    | 16.4%     |\\n| Optics       | 2.2         | 2.5    | 3.7%      |\\n| o/w Terrestrial | 1.7      | 1.8    | 1.9%      |\\n| o/w Submarine  | 0.5      | 0.7    | 9.2%      |\\n| Wireless     | 3.4         | 3.2    | (1.8)%    |\\n| Wireline     | 1.4         | 1.4    | (0.3)%    |\\n| S3G          | 4.4         | 3.9    | (3.9)%    |\\n| Services     | 4.0         | 3.3    | (6.4)%    |\\n| Net Apps     | 0.4         | 0.6    | 9.5%      |\\n| Enterprise   | 0.8         | 0.8    | 2.1%      |\\n| Other        | 0.4         | 0.4    | n.s.      |\\n\\nGross Margins are expected to recover materially from current lows due to a more favorable product mix with a greater share of IP and Optics as well as the exit/restructuring of underperforming businesses, in particular managed services.",
      "categories": ["7.1", "7.2", "7.3", "7.4"],
      "meta": {
        "artefact_type": "tables + strategic outlook",
        "document_section": "Historical Financial Overview",
        "page_number": 63,
        "relevant_entities": ["Alcatel-Lucent"]
      }
    },
    {
      "id": 47,
      "title": "Illustrative Reporting Structure After Re-Allocation of Maintenance",
      "md": "![Figure 58: Illustrative Reporting Structure After Re-Allocation of Maintenance](attachment:007453CF-7634-473A-8784-AAF1B5D8901E.png)\\n\\n**Current Reporting**\\n- Networks\\n  - IP\\n  - Optics\\n    - incl. Optics Terrestrial\\n    - incl. Optics Submarine\\n  - Wireless\\n  - Wireline\\n- Software Services & Solutions\\n  - Services (Professional and Managed)\\n    - incl. Maintenance\\n  - Networks Applications\\n- Enterprise\\n- Other & Eliminations\\n\\n**Potential Future Reporting**\\n- Networks & Platforms\\n  - IP\\n  - Optics Terrestrial\\n  - Wireless\\n  - Fixed Networks\\n  - Platforms\\n- Non Product Attached Services\\n- Focused Businesses\\n  - Enterprise\\n  - Submarine\\n- Other & Eliminations\\n  - incl. Managed Services\\n\\n**Legend:**\\n- Dashed blue box: Maintenance services revenues to be allocated into each of the product divisions\\n- Dashed arrow: Professional services revenues relating to wireless to be allocated to the Wireless subdivision\\n\\nSource: Company",
      "categories": ["7.1", "7.2"],
      "meta": {
        "artefact_type": "organisational diagram",
        "document_section": "Historical Financial Overview",
        "page_number": 63,
        "relevant_entities": ["Alcatel-Lucent"]
      }
    },
    {
      "id": 48,
      "title": "Medium Term Outlook",
      "md": "6) Medium Term Outlook\\nUntil 2015, the Company expects flattish top line growth but a significant improvement in Gross Margins as well as\\noperating profits and EBITDA, which should results in positive cashflow generation.\\nGross Margin\\n\\nTable 11: Summary Medium Term Financial Outlook\\nGrowth\\n€bn LTM Q3 2012 2015E CAGR (%) Delta (€bn)\\nRevenue 14.5 15.2 1.5% 0.7\\nGross Margin 4.5 5.5 6.4% 1.0\\n% revenue 31% 35% - 37%\\nSG&A (2.3) (1.9) (5.7)% 0.4\\n% revenue (16)% (12)% - (14)%\\nR&D (2.3) (2.2) (1.4)% 0.1\\n% revenue (16)% (13.5)% - (15.5)%\\nAdjusted Operating Profit (0.1) 1.3 n.m. 1.4\\n% revenue (0.7)% 6% - 9%\\nAdjusted EBITDA 0.7 2.1 40.2% 1.4\\n% revenue 4.8% 13.5% - 14.5%\\nSource: Company\\n\\nThe key drivers of top line growth are expected to be the IP and Optics division (where Telcos are moving to an\\nall-IP infrastructure), partly offset by modest declines in wireless (where next generation LTE products offset\\nlegacy technology CMDA) as well as services (where the Company is becoming much more selective in the\\ncontracts it takes on).\\n\\nTable 12: Revenue Outlook – LTM Q3 2012 to 2015E\\n€bn LTM Q3 2012 2015E CAGR (%)\\nTotal Revenue 14.5 15.2 1.5%\\nNetworks 8.9 10.0 4.2%\\nIP 1.8 2.9 16.4%\\nOptics 2.2 2.5 3.7%\\no/w Terrestrial 1.7 1.8 1.9%\\no/w Submarine 0.5 0.7 9.2%\\nWireless 3.4 3.2 (1.8)%\\nWireline 1.4 1.4 (0.3)%\\nS3G 4.4 3.9 (3.9)%\\nServices (Professional and Managed) 4.0 3.3 (6.4)%\\nNetworks Applications 0.4 0.6 9.5%\\nEnterprise 0.8 0.8 2.1%\\nOther & Eliminations 0.4 0.4 n.s\\nSource: Company\\n\\nGross Margins are expected to recover materially from current lows due to a more favorable product mix with a\\ngreater share of IP and Optics as well as the exit/restructuring of underperforming businesses, in particular\\nmanaged services.\\n\\nHistorical Financial Overview 65\\n\\nTable 13: Gross Margin Outlook – LTM Q3 2012 to 2015E\\n% LTM Q3 2012 2015E\\nGross margin 31.2% 35% - 37%\\nNetworks 32.3% 33.5% - 34.5%\\nIP 49.0% 47.5% - 48.5%\\nOptics 19.7% 26.0% - 27.0%\\no/w Terrestrial 17.0% 26.0% - 27.0%\\no/w Submarine 28.6% 26.5% - 27.5%\\nWireless 35.2% 32.0% - 33.0%\\nWireline 22.5% 22.0% - 23.0%\\nS3G 24.5% 31.0% - 32.0%\\nServices (Professional and Managed) 22.1% 28.0% - 29.0%\\nNetworks Applications 40.9% 48.0% - 49.0%\\nEnterprise 46.0% 46.0% - 47.0%\\nOther & Eliminations n/m n/m - n/m\\nSource: Company Note: margin of each division based on revenues generated by the division.\\n\\nSummarizing the above table, a bridge from LTM Q3 2012 to 2015E Gross Margins is provided below.\\nGross Margins should reach 35-37% of revenues in FY2015 vs. 31.2%. in LTM Q3 2012. This expansion will be\\ndriven by the following dynamics in particular:\\nn The IP and Optics divisions are expected to contribute 3.0-3.5 points. C. 60% of this improvement is\\nanticipated to come from top line growth in Internet Protocol and c. 40% from business mix improvement in\\nOptics.\\nn The Patent licensing is expected to contribute 1.0 to 1.5 point.\\nn The Managed Services division restructuring – assuming the exit/restructuring of 15 unprofitable contracts – is\\nanticipated to contribute 0.2 to 0.5 point to the Group Gross Margin expansion over the period.\\n\\nFigure 59: Gross Margin Bridge – LTM Q3 2012 to 2015\\n3pt-3.5pt 1pt-1.5pt 0.2pt-0.5pt 0.2pt-0.5pt (0.2)pt-(0.5)pt 35%-37%\\n31.2%\\nLTM\\nQ3 2012\\nSource: Company\\nIP/Optics\\nGrowth\\nPatent\\nLicensing\\nPlatforms Managed\\nServices\\nRestructuring\\nOthers 2015E\\n\\nHistorical Financial Overview 66",
      "categories": ["7.3"],
      "meta": {
        "document_section": "Historical Financial Overview",
        "artefact_type": "narrative and tables",
        "page_number": 65,
        "relevant_entities": ["Alcatel-Lucent"]
      }
    },
    {
      "id": 49,
      "title": "Summary Financials",
      "md": "IX. Summary Financials\\n\\nTable 14: Summary Income Statement (2009A-LTM Q3 2012A)\\n€m 2009A 2010A 2011A Q3 2012 LTM 2009A 2010A 2011A Q3 2012 LTM\\nTotal Revenue YoY Growth (%) 15,157 15,996 15,327 14,500\\n5.5% (4.2)% (5.4)% % Y-o-Y Revenue Growth\\nNetworks 9,076 9,643 9,654 8,873 IP 1,177 1,465 1,585 1,847 Optics 2,853 2,654 2,605 2,234 o/w Terrestrial 1,986 1,988 1,899 1,709 o/w Submarine 867 667 706 525 Wireless 3,547 4,064 4,122 3,393 Wireline 1,618 1,549 1,393 1,440 Other & eliminations (119) (89) (52) (41) S3G 4,344 4,537 4,461 4,492 Services (Professional and Managed) 3,781 4,006 3,963 4,047 Networks Applications 567 531 498 447 Other & eliminations (4) - (1) (1) Enterprise 1,139 1,185 822 772 Excluding Genesys 809 824 822 772 Genesys 316 338 - - Other & eliminations 14 23 - - 6% 0%\\n24% 8%\\n(7)% (2)%\\n0% (4)%\\n(23)% 6%\\n15% 1%\\n(4)% (10)%\\n(26)% (42)%\\n4% (2)%\\n6% (1)%\\n(6)% (6)%\\nn.s. n.s.\\n4% (31)%\\n2% (0)%\\n7% n.s.\\n65% n.s.\\nOther & Eliminations 598 631 391 363 6% (38)%\\n\\nGross Profit 5,111 5,571 5,360 4,528\\n% of revenues 33.7% 34.8% 35.0% 31.2% % of Entity Revenues\\nNetworks 3,057 3,627 3,551 2,862 IP 625 809 827 905 Optics 818 702 544 441 o/w Terrestrial 561 492 329 291 o/w Submarine 258 210 215 150 Wireless 1,250 1,744 1,878 1,193 Wireline 377 373 304 323 Other & eliminations (13) (1) (1) (1) S3G 1,139 1,052 1,146 1,080 Services (Professional and Managed) 873 812 897 896 Networks Applications 260 240 250 183 Other & eliminations 6 - (1) 1 Enterprise 614 642 379 355 Excluding Genesys 358 373 379 355\\nGenesys 256 269 - -\\nOther & Eliminations 301 250 284 231 34% 38% 37% 32%\\n53% 55% 52% 49%\\n29% 26% 21% 20%\\n28% 25% 17% 17%\\n30% 32% 30% 29%\\n35% 43% 46% 35%\\n23% 24% 22% 22%\\nn.s. n.s. n.s. n.s.\\n26% 23% 26% 24%\\n23% 20% 23% 22%\\n46% 45% 50% 41%\\nn.s. n.s. n.s. n.s.\\n54% 54% 46% 46%\\nn.s. n.s. n.s. n.s.\\n\\nR&D expenses (2,372) (2,503) (2,315) (2,305)\\n% of revenues (15.7)% (15.6)% (15.1)% (15.9)% % of Entity Revenues\\nNetworks (1,728) (1,817) (1,740) (1,754) S3G Enterprise Other & Eliminations (192) (203) (212) (204) (172) (159) (95) (120) (280) (325) (268) (227) (19)% (19)% (18)% (20)%\\n(4)% (4)% (5)% (5)%\\n(15)% (13)% (12)% (16)%\\nn.s. n.s. n.s. n.s.\\n\\nSG&A (2,795) (2,781) (2,526) (2,321)\\n% of revenues (18.4)% (17.4)% (16.5)% (16.0)% % of Entity Revenues\\nNetworks (1,626) (1,623) (1,548) (1,376) S3G Enterprise Other & Eliminations (786) (820) (707) (644) (406) (399) (259) (244) 23 61 (12) (57) (18)% (17)% (16)% (16)%\\n(18)% (18)% (16)% (14)%\\n(36)% (34)% (31)% (32)%\\nn.s. n.s. n.s. n.s.\\n\\nAdjusted Operating Profit (Loss) (56) 288 519 (98)\\n% of revenues (0.4)% 1.8% 3.4% (0.7)% % of Entity Revenues\\nNetworks S3G (297) 187 263 (267) 162 30 227 232 Enterprise 36 83 25 (9) Other & Eliminations 44 (12) 4 (54) (3)% 2% 3% (3)%\\n4% 1% 5% 5%\\n3% 7% 3% (1)%\\nn.s. n.s. n.s. n.s.\\n\\nAdjusted EBITDA 572 978 1,257 689\\n% of revenues 3.8% 6.1% 8.2% 4.8%\\n\\nSource: Company. Note: 2009, 2010 financials including Genesys\\nNote: R&D expenses include net capitalization and capital gain.\\n\\nSummary Financials 67\\n\\nTable 15: Summary Cash Flow Statements (2009A-LTM Q3 2012A)\\n€m 2009A 2010A 2011A Q3 2012 LTM\\nAdjusted Operating Income (56) 288 519 (98)\\nNon Cash Adjustments 628 690 738 787\\no/w D&A and Share based payment 758 744 655 680\\no/w OP Non Cash; Other (130) (54) 83 107\\nChange in Operating Working Capital 490 (63) (200) 376\\nChange in Other Working Capital (19) (64) (135) (269)\\nOperating Cash Flow 1,043 851 922 796\\nInterest (172) (257) (253) (209)\\nTaxes (89) (117) (55) (47)\\nCash Contribution to Pension & OPEB (226) (226) (185) (172)\\nRestructuring cash Outlays (561) (377) (344) (338)\\nCash Flow from Operating Activities (5) (126) 85 30\\nCapital Expenditures (Incl. R&D Cap.) (691) (692) (558) (559)\\n% of Revenues (4.6)% (4.3)% (3.6)% (3.9)%\\nFree Cash Flow (696) (818) (473) (529)\\nDisposals, Discontinued, Cash from Financing & Forex 1,959 336 151 1,346\\nDebt Maturities & Early Repurchase (1,244) (327) (993) (234)\\nCash Issuance New Notes 975 676 75 -\\nOther variation in Cash (16) 252 33 365\\nChange in Cash & Marketable Securities 978 119 (1,207) 948\\n\\nCash and Net Debt Position\\nBoP Gross Cash & Marketable Securities 4,593 5,570 5,689 3,757\\nAnnual Change 978 119 (1,207) 948\\nEoP Gross Cash & Marketable Securities 5,570 5,689 4,482 4,705\\n\\nBoP Gross Financial Debt (5,095) (4,755) (5,378) (4,498)\\nDebt Maturities & Early Repurchase 1,244 327 993 234\\nDebt Issued (975) (676) (75) -\\nAccounting Valuation Debentures / Convertibles 12 (42) (71) (281)\\nOther 59 (232) (88) (233)\\nEoP Gross Financial Debt (4,755) (5,378) (4,619) (4,778)\\n\\nGross Financial Debt (4,755) (5,378) (4,619) (4,778)\\nGross Cash & Marketable Securities 5,570 5,689 4,482 4,705\\nDerivatives Interest Rate Instruments 43 42 36 33\\nLoan to Joint Venture 28 24 18 9\\nDerivatives FX instruments - (15) 52 (53)\\nCash / (Net Financial Debt) 886 362 (31) (84)\\n\\nSource: Company\\n\\nfinancing and forex (€17m)\\nNote: in 2009, excluding mark-to-market of FX derivatives, rel",
      "categories": ["7.1", "7.4"],
      "meta": {
        "document_section": "Summary Financials",
        "artefact_type": "tables and narrative",
        "page_number": 67,
        "relevant_entities": ["Alcatel-Lucent"]
      }
    },
    {
      "id": 50,
      "title": "EBITDA Definition and Balance Sheet Summary",
      "md": "Table 16: EBITDA Definition\\n€m 2009A 2010A 2011A\\nQ3 2012\\nLTM\\nAdjusted Operating Income (56) 288 519 (98)\\nAdd Back D&A excluding PPA Adjustments 700 707 627 655\\no/w D&A incl. PPA 969 993 895 903\\no/w elim PPA (269) (286) (268) (248)\\nAdd Back Share Based Payments (SBP) 58 37 28 25\\nAdjusted Operating Income Pre D&A and SBP 702 1,032 1,174 582\\nAdd Back Other Non-Cash Operating Profit Adjustments (130) (54) 83 107\\no/w Employee Benefits Accrual in OP 49 63 63 69\\no/w Product Sales Reserves (172) (43) (58) (53)\\no/w Inventory Reserves 57 62 170 167\\no/w General Risk Reserves (76) (61) (61) (17)\\no/w Capital Gains in OP (7) (23) (37) (36)\\no/w Valuation Allowance Bad Debt 9 1 11 (22)\\no/w Other 10 (53) (5) (1)\\nAdjusted EBITDA 572 978 1,257 689\\nSource: Company\\nNote: 2009A and 2010A financials include Genesys. In 2009 and 2010,” Other” included other financial result considered as cash.\\n\\nSummary Financials 69\\n\\nTable 17: Assets in €m Balance Sheet (2009A-LTM Q3 2012A)\\nDec 31, Dec 31, Dec 31, Sep 30,\\n2009 2010 2011 2012\\nNon-Current Assets\\nGoodwill 4,168 4,370 4,389 4,393\\nIntangible Assets, Net 2,214 2,056 1,774 1,558\\nGoodwill and Intangible Assets, Net 6,382 6,426 6,163 5,951\\nProperty, Plant and Equipment, Net 1,260 1,311 1,263 1,210\\nInvestment In Net Assets of Equity Affiliates 60 9 12 14\\nOther Non-Current Financial Assets, Net 392 400 521 362\\nDeferred Tax Assets 836 948 1,954 1,619\\nPrepaid Pension Costs 2,400 2,746 2,765 3,261\\nOther Non-Current Assets 314 257 296 413\\nTotal Non-Current Assets 11,644 12,097 12,974 12,830\\nCurrent Assets\\nInventories And Work in Progress, Net 1,902 2,295 1,975 2,196\\nTrade Receivables and Other Receivables, Net 3,519 3,664 3,407 2,932\\nAdvances and Progress Payments 93 75 66 61\\nOther Current Assets 960 885 977 718\\nCurrent Income Taxes 157 168 129 127\\nMarketable Securities, Net 1,993 649 939 1,747\\nCash and Cash Equivalents 3,577 5,040 3,534 2,958\\nCurrent Assets Before Assets Held for Sale 12,201 12,776 11,027 10,739\\nAssets Held for Sale and Assets Included in Disposal Groups\\nHeld for Sale 51 3 202 2\\nTotal Current Assets 12,252 12,779 11,229 10,741\\nTotal Assets 23,896 24,876 24,203 23,571",
      "categories": ["7.1", "7.4"],
      "meta": {
        "document_section": "Summary Financials",
        "artefact_type": "tables and narrative",
        "page_number": 69,
        "relevant_entities": ["Alcatel-Lucent"]
      }
    },
    {
      "id": 51,
      "title": "Guarantor Package and Glossary",
      "md": "Equity and Liabilities\\nEquity\\nCapital Stock 4,636 4,637 4,651 4,653\\nAdditional Paid-in Capital 16,689 16,726 16,757 16,774\\nLess Treasury Stock at Cost (1,567) (1,566) (1,567) (1,567)\\nAccumulated Deficit, Fair Value and Other Reserves (14,518) (15,139) (16,536) (16,026)\\nCumulative Translation Adjustments (976) (779) (546) (483)\\nNet Income (Loss) - Attributable to the Equity Owners of the\\nParent (524) (334) 1,095 (2)\\nEquity Attributable to Equity Owners of the Parent 3,740 3,545 3,854 3,349\\nNon-Controlling Interests 569 660 747 826\\nTotal Equity 4,309 4,205 4,601 4,175\\nNon-Current Liabilities\\nPensions, Retirement Indemnities and Other Post-Retirement benefits\\nRetirement Benefits 5,043 5,090 5,706 6,187\\nConvertible Bonds and Other Bonds, Long-Term 4,084 4,037 4,152 3,753\\nOther Long-Term Debt 95 75 138 211\\nDeferred Tax Liabilities 1,058 1,126 1,017 1,027\\nOther Non-Current Liabilities 209 259 211 174\\nTotal Non-Current Liabilities 10,489 10,587 11,224 11,352\\nCurrent Liabilities\\nProvisions 2,122 1,858 1,579 1,466\\nCurrent Portion of Long-Term Debt and Short-Term Debt 576 1,266 329 814\\nCustomers’ Deposits and Advances 639 803 590 758\\nTrade Payables And Other Payables 3,926 4,325 3,892 3,693\\nCurrent Income Tax Liabilities 72 137 131 122\\nOther Current Liabilities 1,763 1,695 1,729 1,191\\nCurrent Liabilities Before Liabilities Related to Disposal Groups\\nHeld for Sale 9,098 10,084 8,250 8,044\\nLiabilities Related to Disposal Groups Held for Sale - - 128 -\\nTotal Current Liabilities 9,098 10,084 8,378 8,044\\nTotal Equity and Liabilities 23,896 24,876 24,203 23,571\\nSource: Company Filings\\n\\nSummary Financials 70\\n\\nTable 18: Current Proposed Guarantor Package (Contribution of Sales, EBITDA and Assets to\\nconsolidated metrics)\\n9M 2012 (€m) Sales LTM Sep\\nEBITDA Assets\\nUS guarantors¹ 3,596 991 8,284\\n% of Total 34.7% 169.7% 35.1%\\nNon-US guarantors 833 (65) 4,164\\n% of Total 8.0% (11.1)% 17.7%\\nTotal guarantors (excl. ALU int'l) 4,429 926 12,488\\n% of Total 42.8% 158.6% 53.0%\\nConsolidated metrics 10,350 584 23,571\\nSource: Company 1 ALU USA Inc., standalone only data. The other US subsidiary guarantors do not have meaningful operations or generate meaningful sales.\\nNote: the guarantor package described above excludes certain legal entities in the Netherlands and Germany. The parties agree to work in good\\nfaith to add these entities to the guarantor group as soon as possible subject to local law constraints and/or timing issues. The entities may not be\\npart of the guarantor group at closing. Pro forma for the addition of the legal entities in Germany and the Netherlands, the guarantor coverage\\nmetrics would be 47% of consolidated sales, 176% of consolidated EBITDA and 54% of consolidated assets.\\n\\nSummary Financials 71\\n\\nX. Glossary\\nA\\nM\\nADSL Asymmetric digital subscriber line\\nMB Megabyte\\nARPU Average revenue per user (per month)\\nMbps Megabit per second (a unit of data\\ntransfer rate)\\nATM Asynchronous transfer mode\\nB\\nMHz Megahertz (a unit of frequency)\\nMNO Mobile network operator\\nBB Broadband\\nMPLS Multi-protocol label switching\\nC\\nMVNO Mobile virtual network operator\\nCAGR Compound annual growth rate\\nN\\nCapex Capital expenditure\\nN/A Not applicable / Not available\\nCDMA Code division multiple access\\nNMC Network management centre\\nCDN Content Delivery Network\\nNOC Network operation centre\\nCOGS Cost of goods sold\\nNGN Next generation network\\nCRM Customer relationship management\\nO\\nD\\nDSL Digital subscriber line\\nDWDM Dense wavelength division multiplexing\\nE\\nEBITDA Earnings before interest, taxes,\\ndepreciation & amortization\\nF\\nFDD Frequency division duplexing\\nFM Frequency modulation (analogue\\nradio)\\nOFDM Orthogonal frequency-division\\nmultiplexing\\nQoS Quality of service\\nOpex Operational expenditure\\nOSS Operational support systems\\nOTN Optical Transport Network\\nP-R\\nPBX Private branch exchange\\nPOTS Plain old telephone service\\nRAN Radio access network\\nFWA Fixed wireless access\\nG\\nS\\nGbps Gigabit per second (a unit of data\\ntransfer rate)\\nSDH Synchronous digital hierarchy\\nGHz Gigahertz (a unit of frequency)\\nGSM Global system for mobile\\ncommunication\\nH\\nHSPA I-L\\nHigh speed packet access (a collection\\nof two mobile telephony protocols)\\nICT Information and communications\\ntechnology\\nIFRS International financial reporting\\nstandards\\nIP Internet protocol\\nU-V\\nUMTS Universal mobile telecommunications\\nservice\\nVAS Value added services\\nVoD Video on demand\\nVoIP Voice over internet protocol\\nVPN Virtual private network\\nW\\nW Watts\\nWDM Wavelength division multiplexing\\nWifi Wireless fidelity\\nWiMAX Worldwide interoperability for\\nMicrowave Access\\nIPTV Internet protocol television\\nX\\nIP-VPN Internet protocol virtual private\\nnetworks\\nxDSL Generic term for all DSL technologies\\nISP Internet service provider\\nKbps Kilobit per second (a unit of data\\ntransfer rate)\\nLAN Local area network\\nLTE Long-term evolution\\n\\nGlossary 72",
      "categories": ["7.1", "8.2"],
      "meta": {
        "document_section": "Summary Financials and Glossary",
        "artefact_type": "tables and glossary",
        "page_number": 70,
        "relevant_entities": ["Alcatel-Lucent", "ALU USA Inc."]
      }
    }
  ]`;

  useEffect(() => {

    onLoad();
  }, []);


  async function onLoad() {
    if (!isAuthenticated) { history.push("/"); return; }


  }

  ///////////////// UPLOADER //////////////////////////

  function createSite(site) {
    return API.post("aires", "/sites", {
      body: site
    });
  }
  async function buildSite(content) {
    try {
      console.log(content);
      //const result = await createSite({ content: content, image: "", itemStatus: 8}); // itemStatus -> DEfault = 8 (i.e. NON-Airestop site)
      return true;
    } catch (e) {
      onError(e);
      return false;
    }


  }


  var datafiles;
  var fileIndex = 0;

  const handleFile = e => {
    const content = e.target.result;








    /*
      try {
        const result = await uploadData({ aaa:111});
        readNextFile();
      } catch (e) {
        onError(e);
        setIsUploading(false);
      }
        */
  }
  /*
  function readNextFile() {
    fileIndex += 1;
    if (fileIndex >= datafiles.length) {
      setIsUploading(false);
      return;
    }
    var reader = new FileReader();
    reader.onloadend = handleFile;
    var f = datafiles[fileIndex];
    reader.readAsText(f);
  }
    */




  function readNextFile() {
    //console.log(datafiles);
    fileIndex += 1;
    if (fileIndex >= datafiles.length) {
      setIsUploading(false);
      return;
    }
    var reader = new FileReader();
    reader.onloadend = handleFile;
    var f = datafiles[fileIndex];
    reader.readAsText(f);
  }






  function uploadData(data) {
    //console.log(data);

    return API.post("spivolaaatsss", "/org/sitesaaaaaaaaaa", {
      body: data
    });

  }

  function parseDoc(body) {
    return API.post("findigai", "/parse", {
      body: body
    });
  }





  function uploadDoc(body) {
    return API.post("findigai", "/documents/create", {
      body: body
    });
  }

  function getDocuments() {
    return API.get("findigai", "/documents");
  }
  function getOpenAI(body) {
    return API.post("findigai", "/openai", {
      body: body
    });
  }
  /*
    const pollParsingStatus = async () => {
      if (isParsing) {
        console.log("polling c");
        if (!jobId) return;
        try {
          const resultJob = await parseDoc({ type: "job", id: jobId });
          console.log(resultJob)
          const { status } = resultJob.data;
          setParsingStatus(status);
  
          if (status !== "PENDING") { //PENDING, SUCCESS, ERROR, PARTIAL_SUCCESS, CANCELLED
            setIsParsing(false);
            if (status === "SUCCESS") {
  
              artifactise();
  
  
            } else {
              console.log("DOC PARSING FAILED: ", status)
            }
          }
        } catch (error) {
          console.error('Error checking parsing status:', error);
        }
      }
    };
  */
  /*
    const pollArtefactisationStatus = async () => {
      if (isArtefacting) {
        console.log("polling art a");
        if (!docId) return;
        try {
          const resultArt = await getOpenAI({type: 'artefactisation', docid: docId});
  
          console.log(resultJob)
  
          const { status } = resultJob.data;
          setParsingStatus(status);
  
          if (status !== "PENDING") { //PENDING, SUCCESS, ERROR, PARTIAL_SUCCESS, CANCELLED
            setIsParsing(false);
            if (status === "SUCCESS") {
              const resultJobData = await parseDoc({type: "jobresult", id: jobId, output:"json"});
              console.log(resultJobData)
  
  
              //const {markdown} = resultJobData.data;
              const {structured} = resultJobData.data;
              const hier = buildHierarchy(structured);
  
              setParsedData(hier);
  
  
            }
          }
        } catch (error) {
          console.error('Error checking parsing status:', error);
        }
      }
    };
    */


  // Set up a polling mechanism that checks every 5 seconds until completed
  useEffect(() => {
    console.log("polling");
    let pollingInterval;

    if (isParsing) {
      console.log("polling b");
      pollingInterval = setInterval(pollParsingStatus, 5000); // Check every 5 seconds
    }
    try {
      return () => clearInterval(pollingInterval); // Clear polling on unmount or when parsing stops
    } catch (e) {
      // do nowt
    }

  }, [isParsing, jobId]);

  /*
  useEffect(() => {
    console.log("polling art");
    let pollingInterval;

    if (isArtefacting) {
      console.log("polling art b");
      pollingInterval = setInterval(pollArtefactisationStatus, 5000); // Check every 5 seconds
    }
    try{
      return () => clearInterval(pollingInterval); // Clear polling on unmount or when parsing stops
    } catch(e) {
      // do nowt
    }
    
  }, [isArtefacting, docId]);
*/



  async function handleFolderPick() {
    try {
      // Ask the user to pick a directory
      const dirHandle = await window.showDirectoryPicker();

      // Iterate over files in the directory
      for await (const [name, handle] of dirHandle.entries()) {
        if (handle.kind === "file" && name.toLowerCase().endsWith(".pdf")) {
          const file = await handle.getFile();
          console.log("PDF found:", file.name, file);

          // Example: read as ArrayBuffer
          const arrayBuffer = await file.arrayBuffer();
          console.log("Loaded", file.name, "size:", arrayBuffer.byteLength);
        }
      }
    } catch (err) {
      if (err.name === "AbortError") {
        console.log("User cancelled folder selection");
      } else {
        console.error("Error picking folder:", err);
      }
    }
  }


  useEffect(() => {
    let pollingInterval;
    if (isRunning) {
      pollingInterval = setInterval(updateResultsStatus, 300); // Check every 5 seconds
    }
    try {
      return () => {
        clearInterval(pollingInterval);
      } // Clear polling on unmount or when parsing stops
    } catch (e) {
      // do nowt
    }
  }, [isRunning]); //

  const updateResultsStatus = () => {
    const timeDiff = (Date.now() - startTimeRef.current) / 1000;
    setResultsStatus(timeDiff)

  }



  useEffect(() => {
    //console.log("polling");
    let pollingInterval;
    if (isRunning && jobId) {
      pollingInterval = setInterval(pollParsingStatus, 5000); // Check every 5 seconds
    }
    try {
      return () => clearInterval(pollingInterval); // Clear polling on unmount or when parsing stops
    } catch (e) {
      // do nowt
    }

  }, [isRunning, jobId]);


  const pollParsingStatus = async () => {

    if (isRunning) {
      if (isCancelling) {
        setIsRunning(false);
        setResultsData("Cancelled ok!");
        setIsCancelling(false);
        // should request a cancellation to llamaparse here
      } else {
        try {
          if (!jobId) return;
          const resultJob = await parseDoc({ type: "job", id: jobId });
          const { status } = resultJob.data;
          console.log(status, status !== "PENDING", status === "SUCCESS")
          //resultsData += " " + status
          //setResultsData(resultsData);
          if (status !== "PENDING") { //PENDING, SUCCESS, ERROR, PARTIAL_SUCCESS, CANCELLED
            if (status === "SUCCESS") {
              setJobId(null);
              setResultsData("parsing completed ok!");


              const clues = await runCluesQuery();
              if (clues.status) {
                //setIsRunning(false);
                //setResultsData(clues.result);
                console.log(clues.result);
                const extract = await runExtractionQuery(clues.result);
                if (extract.status) {



                  await processNextFile();


                  //setResultsData(extract.result);
                  // console.log(extract.result);
                  //setIsRunning(false);
                  // await onComplete();






                } else {
                  await processNextFile();
                  //setIsRunning(false);
                  //setResultsData("extractQuery failed: " + extract.result);
                  console.log("extractQuery failed: " + extract.result);
                }



              } else {
                await processNextFile();
                //setIsRunning(false);
                //setResultsData("cluesQuery failed: " + clues.result);
                console.log("cluesQuery failed: " + clues.result);
              }
            } else {
              await processNextFile();
              //setIsRunning(false);
              //setResultsData("parsing failed: " + status);
              console.log("DOC PARSING FAILED: ", status)
            };

          }
        } catch (error) {
          await processNextFile();
          //setIsRunning(false);
          //setResultsData("parsing failed: " + error.message);
          console.error('Error checking parsing status:', error);
        }
      }
    }

  };

  async function onComplete() {
    const result = await getTuningRecords(processingState.processId);
    if (result.status) {
      console.log(result.data);
      downloadZip(result.data);
    }
  }

  async function runExtractionQuery(clues) {
    let resultsStr = "";
    try {
      const file = files[processingState.currentIndex];
      const result = await getOpenAI({ type: "tableextract", clues: clues, processId: processingState.processId, fileName: file.name, keyId: processingState.userKey, config: getConfigObj() });
      console.log(result);
      resultsStr = result.body;
      return { status: true, result: resultsStr };
    } catch (err) {
      console.error("OpenAI Error:", err?.response?.data || err.message || err);
      resultsStr = "OpenAI Error: " + err?.response?.data || err.message || err;
      return { status: true, result: resultsStr };
    }
  }

  async function runCluesQuery() {
    let resultsStr = "";
    try {
      const file = files[processingState.currentIndex];
      const result = await getOpenAI({ type: "tableclues", processId: processingState.processId, fileName: file.name, keyId: processingState.userKey, config: getConfigObj() });
      console.log(result);
      resultsStr = result.body;
      return { status: true, result: resultsStr };
    } catch (err) {
      console.error("OpenAI Error:", err?.response?.data || err.message || err);
      resultsStr = "OpenAI Error: " + err?.response?.data || err.message || err;
      return { status: true, result: resultsStr };
    }
  }

  function downloadZip(csvFiles) {
    const zip = new JSZip();
    csvFiles.forEach((file) => {
      if (file.name && file.ntab) {
        const fn = file.name.substring(0, file.name.lastIndexOf(".")) || file.name;
        zip.file( "dirty_" + fn + ".csv", file.ntab);
      }
    });
    // Generate the zip and trigger download
    zip.generateAsync({ type: "blob" }).then((blob) => {
      saveAs(blob, "dirty_ntabs.zip"); // triggers a download
    });

  }

  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    if (!isAuthenticated) { history.push("/"); return; }
    loadConfig();
  }

  const loadConfig = async () => {
    const result = await getConfig();
    let cf = {};
    for (let i = 0; i < result.data.length; i++) {
      const val = result.data[i];
      const skArr = val.sk.split("|");
      const step = skArr[skArr.length - 1];
      cf[step.toLowerCase()] = val.content;
    }
    setPromptUserExtraction(cf.tabfinetune.options.promptUserExtraction);
    setPromptSysExtraction(cf.tabfinetune.options.promptSysExtraction);
    setPromptUserClues(cf.tabfinetune.options.promptUserClues);
    setPromptSysClues(cf.tabfinetune.options.setPromptSysClues);
    setTemperature(cf.tabfinetune.options.temperature);
    setTopP(cf.tabfinetune.options.topP);
    setPresencePenalty(cf.tabfinetune.options.presencePenalty);
    setFrequencyPenalty(cf.tabfinetune.options.frequencyPenalty);
    setSelectedModel(cf.tabfinetune.options.model);
    setProcessIdOptions(cf.tabfinetune.options.processIds);
  }

  function getConfig() {
    return API.get("findigai", "/config");
  }

  function getTuningRecords(processId) {
    return API.get("findigai", `/tuning/${processId}`);
  }

  const handleFolderSelect = async (event) => {
    const files = Array.from(event.target.files);
    setProcessingState(prev => ({ ...prev, currentIndex: -1, isActive: false, fileCount: files.length}));
    setFiles(files);
    setResultsStatus('0');
    setStatusText(String(files.length) + " table files to process");
  }

  async function processNextFile(processId = null) {
    const newKey = processingState.userKey==1?2:1;
    const idx = processingState.currentIndex + 1;
    if (idx >= processingState.fileCount) {
      setStatusText("Processing completed");
      setIsRunning(false);
      await onComplete();
    } else {
      if (processId) {
        setProcessingState(prev => ({ ...prev, currentIndex: idx, processId: processId, isActive: true}));
      } else {
        setProcessingState(prev => ({ ...prev, currentIndex: idx, userKey: newKey}));
      }
      const file = files[idx];
      setFileDetails(null);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = async () => {
        const base64String = reader.result.split(',')[1]; // Get base64 data
        console.log(base64String);
        uploadDoc({ type: "parse-for-tuning", processId: selectedProcessIdOption.value, doc: base64String, fileName: file.name })
          .then(resultParse => {
            console.log("Got data:", resultParse);
            const data = typeof resultParse.data === "string" ? JSON.parse(resultParse.data) : resultParse.data;
            const { id, status } = data;
            console.log(data);
            setJobId(id);
          })
          .catch(err => {
            console.error('Error processing file:', err);
          });
      };
    }
  }

  const handleProcessFilesClick = async (event) => {
    if (selectedProcessIdOption && selectedProcessIdOption.value != "") {
      setIsRunning(true);
      startTimeRef.current = Date.now();
      setResultsData('Parsing...')
      await processNextFile(selectedProcessIdOption.value);
    }
  }

  function uploadDoc(body) {
    return API.post("findigai", "/parse", {
      body: body
    });
  }


  const handleUploadClick = async (event) => {
    event.preventDefault();
    if (isUploading) {
      return;
    }
    console.log(event.target.files.length);
    if (event.target.files.length == 0) {
      return;
    }

    const file = event.target.files[0];
    const result = await getDocuments();
    let isDuplicate = false;
    let version = 0;
    for (const doc of result.data) {
      if (doc.name == file.name) {
        isDuplicate = true;
        if (doc.version && doc.version > version) {
          version = doc.version;
        }
      }
    }
    version++;
    setFileDetails({ file: event.target.files[0], version: version, isDuplicate: isDuplicate });
    if (!isDuplicate) {
      uploadParseDoc();
    }
  }

  const continueFileUpload = (event) => {
    event.preventDefault();
    uploadParseDoc();
  }


  const uploadParseDoc = async () => {
    //console.log("uploadParseDoc");
    setIsUploading(true);
    fileIndex = -1;
    const file = fileDetails.file;
    const version = fileDetails.version;
    setFileDetails(null);
    //console.log(file);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = async () => {
      const base64String = reader.result.split(',')[1]; // Get base64 data
      try {
        const resultParse = await parseDoc({ doc: base64String, fileName: file.name, version: version, promptAppend: systemPromptAppend });
        console.log(resultParse)
        const data = typeof resultParse.data === "string" ? JSON.parse(resultParse.data) : resultParse.data;
        setDocId(resultParse.docId);
        const { id, status } = data;
        setParsingStatus(status);
        setJobId(id);
        setIsParsing(true);
        setFileUrl(resultParse.location);
      } catch (error) {
        console.error('Error uploading file:', error);
      }
    };
    setIsUploading(false);
  }


  function buildHierarchy(parsedJson) {
    const hierarchy = [];
    const stack = [{ level: 0, children: hierarchy }]; // Root container

    parsedJson.forEach((item) => {
      const match = item.text.match(/^(#+)\s*(.*)/); // Detect Markdown-style headers

      if (match) {
        const level = match[1].length; // Number of '#' determines heading level
        const title = match[2];

        const newNode = { title, level, children: [] };

        // Find the correct parent in the stack
        while (stack.length && stack[stack.length - 1].level >= level) {
          stack.pop();
        }

        stack[stack.length - 1].children.push(newNode);
        stack.push(newNode);
      }
    });

    return hierarchy;
  }


  function renderLoader() {
    return (
      <div id="splash" style={{ paddingTop: 100, zIndex: 999 }}>

        <center id="splash">
          <img src={spinner} height="30px" width="auto" />
          {/*}<Typography style={{padding: '4px'}} variant="caption">{label}</Typography>*/}
        </center>
      </div>


    );

  }
  const getJob = async (e) => {
    e.preventDefault();
    if (jobId != "") {
      //const resultJobData = await parseDoc({type: "jobresult", id: jobId, output:"json"});
      const resultJobData = await parseDoc({ type: "reformat", id: jobId, output: "json" });
      //console.log(resultJobData)
      setParsedData(resultJobData.data);


    }


  }



  const runArtefactisation = async (e) => {
    e.preventDefault();
    artifactise();
  }

  const artifactise = async () => {
    setIsArtefacting(true);
    setArtifactingStatus("Artifacting started...");
    let artStatus = 0;
    let message;
    while (artStatus < 2) {
      const result = await getOpenAI({ type: 'artefactisation', docid: docId });
      message = result;
      if (result.statusCode == 500) { // ERROR
        // delete all new records for the docid
        artStatus = 9;
      } else if (result.statusCode == 200) {
        if (result.documentStatus) {
          artStatus = result.documentStatus;
          const status = "Completed: page " + String(result.page) + " of " + String(result.pages);
          console.log(status);
          setArtifactingStatus(status);
        } else {
          // delete all new records for the docid
          result["extrainfo"] = "ERROR: no documentStatus in result with status 200";
          message = result;
          artStatus = 9;
        }
      }
    }
    if (artStatus == 2) {
      message = "Artefacting completed successfully!";
    } else if (artStatus != 9) {
      message = `"ERROR: Terminated with incorrect artStatus: ${artStatus}`;
    }
    console.log(message);
    setArtifactingStatus(message);
    setIsArtefacting(false);
  }

  const uploadOmarArtifacts = async (e) => {
    e.preventDefault();
    const result = await uploadDoc({ name: docTitle, assetType: 0, description: docDesc, userName: "Andrew", doc: artifactsDoc });
    console.log(result);
  }
  const getDocs = async (e) => {
    e.preventDefault();
    const result = await getDocuments();
    setDocuments(result.data);
    //console.log(result);
  }

  const doQuery = async (e) => {
    e.preventDefault();
    if (isUploading) {
      return;
    }
    setIsUploading(true);
    //const result = await getDocuments();
    //setDocuments(result.data);


    if (selectedCategories && selectedCategories.length < 1) {
      alert("Please select at least one category.");
      return;
    }


    //console.log(selectedKeys);

    let allNumbers = [];
    for (const cat in selectedCategories) {
      console.log(selectedCategories[cat]);
      console.log(categories[selectedCategories[cat]]);

      const ids = categories[selectedCategories[cat]].artefactIds;


      // Merge & deduplicate
      allNumbers = [...allNumbers, ...ids];


    }
    const uniqueIds = [...new Set(allNumbers)];
    console.log(uniqueIds);
    const uniqueSortedNumbers = [...new Set(allNumbers)].sort((a, b) => a - b);
    console.log(uniqueSortedNumbers);

    //"Identify any risks with this company?"

    const body = { cats: uniqueSortedNumbers, prompt: prompt, model: selectedModel };
    //const result = await getOpenAI(body);
    try {
      const result = await getOpenAI({ cats: uniqueSortedNumbers, prompt: prompt, model: selectedModel });
      console.log(body);
      //console.log(result);
      setOpenaiData(result.data);
    } catch (err) {
      console.error("OpenAI Error:", err?.response?.data || err.message || err);
    }

    setIsUploading(false);



  }

  /*
    function updateConfig(body) {
      setConfig(prev => ({
        ...prev,
        [body.type]: body.values,
      }));
      return API.patch("findigai", "/config", {
        body: body
      });
    }
      */

  const openFileDialog = () => {
    const input = document.getElementById("upload-data");
    input.value = ""; // Reset the input to allow re-selection of the same file
    //input.click();
  };
  /*
    const saveConfig = async () => {
      const body = getConfigObj();
      await updateConfig(body);
    }
      */
  function getConfigObj() {
    return { type: "tabfinetune", values: { options: { promptSysClues: promptSysClues, promptUserClues: promptUserClues, promptSysExtraction: promptSysExtraction, promptUserExtraction: promptUserExtraction, model: selectedModel, temperature: temperature, topP: topP, presencePenalty: presencePenalty, frequencyPenalty: frequencyPenalty, processIds: processIdOptions } } };
  }


  const handleTopPChange = async (e) => {
    e.preventDefault();
    let newValue = Number(e.target.value);
    if (newValue >= 1) newValue = 1.0;
    if (newValue < 1) newValue = 0.0;
    setTopP(newValue);
  }
  const handleTemperatureChange = async (e) => {
    e.preventDefault();
    let newValue = Number(e.target.value);
    if (newValue >= 1) newValue = 1.0;
    if (newValue < 1) newValue = 0.0;
    setTemperature(newValue);
  }
  const handlePresencePenaltyChange = async (e) => {
    e.preventDefault();
    let newValue = Number(e.target.value);
    if (newValue >= 1) newValue = 1.0;
    if (newValue < 1) newValue = 0.0;
    setPresencePenalty(newValue);
  }
  const handleFrequencyPenaltyChange = async (e) => {
    e.preventDefault();
    let newValue = Number(e.target.value);
    if (newValue >= 1) newValue = 1.0;
    if (newValue < 1) newValue = 0.0;
    setFrequencyPenalty(newValue);
  }


  function renderLander() {
    return (
      <>
        <Box sx={{ width: "100%" }}>
          <h2 style={{ margin: 0 }}>Fine Tuning PipeLine (Stage 1)</h2>
          <Box p={2} >
            <label htmlFor="upload-data">
              <input
                disabled={isRunning}
                accept=".PDF"

                id="upload-data"
                name="upload-data"
                multiple="false"
                type="file"
                onChange={handleFolderSelect}
                hidden
              />
              <Button disabled={isRunning} onClick={openFileDialog} color="primary" variant="contained" component="span" startIcon={<QueueIcon />}>Select table files (.pdf)</Button>

            </label>
          </Box>

          {files.length > 0 &&
            <>
              <Box p={2} >
                <h6> {statusText}{Number(resultsStatus)>0?" - " + String(Number(resultsStatus).toFixed(2)) + " seconds.":""}</h6>
              </Box>

              <Box p={2} >
                <span style={{ display: "flex", alignItems: "baseline", gap: "8px" }}>
                  <h3 style={{ margin: 0 }}>Process ID:</h3>
                  <h6 style={{ margin: 0 }}> (only use letters, numbers, underscores and dash)</h6>
                </span>
                <h3>
                  <CreatableSelect
                    disabled={isRunning}
                    isClearable
                    onChange={handleProcessIdChange}
                    onCreateOption={handleProcessIdCreate}
                    onInputChange={(input) => input.replace(/[^A-Za-z0-9_-]/g, "")}
                    styles={customStyles}
                    options={processIdOptions}
                    value={selectedProcessIdOption}
                    placeholder="Select or type to add..."
                    formatCreateLabel={(inputValue) => `➕ Add "${inputValue}"`}
                  />
                </h3>
              </Box>
              <Box p={2} >
                <Button disabled={!selectedProcessIdOption || isRunning} onClick={handleProcessFilesClick} color="primary" variant="contained" component="span" startIcon={<PlayArrowIcon />}>Process files for fine tuning</Button>
              </Box>
              <Box mt={1} sx={{ width: "100%" }}>
                <Paper style={{ backgroundColor: "#f2f2ff" }}>
                  <Box p={2}>


                    <Box pv={2} pl={0.5}>
                      <h6>System prompt (CLUES)</h6>
                    </Box>

                    {/*}
                        <Typography variant="body2" style={{ fontSize: '0.8rem' }}>
                            NB: Must include <span style={{ color: "#922821", fontWeight: "bold" }}><i>{"{{{categories}}}"}</i></span> and <span style={{ color: "#922821", fontWeight: "bold" }}><i>{"{{{output-format}}}"}</i></span><br />
                        </Typography>
                        */}
                    <TextareaAutosize
                      disabled={isRunning}
                      minRows={1}
                      placeholder="<empty>"
                      value={promptSysClues}
                      onChange={(e) => setPromptSysClues(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px',
                        fontSize: '16px',
                        borderRadius: '8px',
                        border: '1px solid #ccc',
                        resize: 'vertical',
                      }}
                    />
                    <Box pt={3} pb={0} pl={0.5} >
                      <h6>User prompt (CLUES)</h6>
                    </Box>

                    <Typography variant="body2" style={{ fontSize: '0.8rem' }}>
                      &nbsp;&nbsp;NB: Must include <span style={{ color: "#922821", fontWeight: "bold" }}><i>{"{{{tab-md}}}"}</i></span><br />
                    </Typography>
                    <TextareaAutosize
                      disabled={isRunning}
                      minRows={1}
                      placeholder="<empty>"
                      value={promptUserClues}
                      onChange={(e) => setPromptUserClues(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px',
                        fontSize: '16px',
                        borderRadius: '8px',
                        border: '1px solid #ccc',
                        resize: 'vertical',
                      }}
                    />



                    <Box pv={2} pl={0.5} pt={4}>
                      <h6>System prompt (EXTRACTION)</h6>
                    </Box>

                    {/*}
                        <Typography variant="body2" style={{ fontSize: '0.8rem' }}>
                            NB: Must include <span style={{ color: "#922821", fontWeight: "bold" }}><i>{"{{{categories}}}"}</i></span> and <span style={{ color: "#922821", fontWeight: "bold" }}><i>{"{{{output-format}}}"}</i></span><br />
                        </Typography>
                        */}
                    <TextareaAutosize
                      disabled={isRunning}
                      minRows={1}
                      placeholder="<empty>"
                      value={promptSysExtraction}
                      onChange={(e) => setPromptSysExtraction(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px',
                        fontSize: '16px',
                        borderRadius: '8px',
                        border: '1px solid #ccc',
                        resize: 'vertical',
                      }}
                    />
                    <Box pt={3} pb={0} pl={0.5} >
                      <h6>User prompt (EXTRACTION)</h6>
                    </Box>

                    <Typography variant="body2" style={{ fontSize: '0.8rem' }}>
                      &nbsp;&nbsp;NB: Must include <span style={{ color: "#922821", fontWeight: "bold" }}><i>{"{{{tab-md}}}"}</i></span> and <span style={{ color: "#922821", fontWeight: "bold" }}><i>{"{{{tab-clues}}}"}</i></span><br />
                    </Typography>
                    <TextareaAutosize
                      disabled={isRunning}
                      minRows={1}
                      placeholder="<empty>"
                      value={promptUserExtraction}
                      onChange={(e) => setPromptUserExtraction(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px',
                        fontSize: '16px',
                        borderRadius: '8px',
                        border: '1px solid #ccc',
                        resize: 'vertical',
                      }}
                    />

                    <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                      <Box width={26} pt={3} pb={0} pl={0.5} >
                        <Paper>
                          <TextField
                            type="number"
                            disabled={isRunning}
                            value={temperature}
                            onChange={handleTemperatureChange}
                            disableUnderline
                            inputProps={{
                              disableUnderline: true,
                              min: 0,
                              max: 1,
                            }}
                          />
                        </Paper>
                      </Box>
                      <Box pt={3} pb={0} pl={0.5} >
                        <h6> Temperature</h6>
                      </Box>
                    </Box>

                    <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                      <Box width={26} pt={3} pb={0} pl={0.5} >
                        <Paper>
                          <TextField
                            type="number"
                            disabled={isRunning}
                            value={topP}
                            onChange={handleTopPChange}
                            disableUnderline
                            inputProps={{
                              disableUnderline: true,
                              min: 0,
                              max: 1,
                            }}
                          />
                        </Paper>
                      </Box>
                      <Box pt={3} pb={0} pl={0.5} >
                        <h6> Top P</h6>
                      </Box>
                    </Box>

                    <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                      <Box width={26} pt={3} pb={0} pl={0.5} >
                        <Paper>
                          <TextField
                            type="number"
                            disabled={isRunning}
                            value={presencePenalty}
                            onChange={handlePresencePenaltyChange}
                            disableUnderline
                            inputProps={{
                              disableUnderline: true,
                              min: 0,
                              max: 1,
                            }}
                          />
                        </Paper>
                      </Box>
                      <Box pt={3} pb={0} pl={0.5} >
                        <h6> Presence penalty</h6>
                      </Box>
                    </Box>
                    <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                      <Box width={26} pt={3} pb={0} pl={0.5} >
                        <Paper>
                          <TextField
                            type="number"
                            disabled={isRunning}
                            value={frequencyPenalty}
                            onChange={handleFrequencyPenaltyChange}
                            disableUnderline
                            inputProps={{
                              disableUnderline: true,
                              min: 0,
                              max: 1,
                            }}
                          />
                        </Paper>
                      </Box>
                      <Box pt={3} pb={0} pl={0.5} >
                        <h6> Frequency penalty</h6>
                      </Box>
                    </Box>

                    <Box my={2} ml={0.5}>
                      <select
                        id="model"
                        disabled={isRunning}
                        value={selectedModel}
                        onChange={(e) => setSelectedModel(e.target.value)}
                      >
                        {models.map((model) => (
                          <option key={model.value} value={model.value}>
                            {model.label}
                          </option>
                        ))}
                      </select>

                    </Box>


                  </Box>
                </Paper>
              </Box>



            </>
          }

          {/*}
      
          <Box p={2} >
            <label htmlFor="upload-data">


<input type="file" webkitdirectory="true" onChange={handleFolderSelect} />
          </label>
          </Box>


<Box p={2} >
          <button onClick={handleFolderPick}>Choose Folder</button>
</Box>
         

          <Box p={2} >
            <Button onClick={getJob} color="primary" variant="contained" component="span" startIcon={<CloudUploadIcon />}>Get result for</Button>
            <input
              type="text"
              placeholder="Job id"
              value={jobId}
              onChange={(e) => setJobId(e.target.value)}
            />
          </Box>

          <Box p={2} >
            {isParsing && <p>Parsing in progress...</p>}
            {parsingStatus && <p>Parsing Status: {parsingStatus}</p>}
            {isArtefacting && <p>Artifacting in progress...</p>}
            {artifactingStatus && <p>Parsing Status: {artifactingStatus}</p>}
           

          </Box>


          <Box p={2} >
            <Button onClick={uploadOmarArtifacts} color="primary" variant="contained" component="span" startIcon={<CloudUploadIcon />}>upload omar artifacts</Button>
            <input
              type="text"
              placeholder="doc title"
              value={docTitle}
              onChange={(e) => setDocTitle(e.target.value)}
            />
            <input
              type="text"
              placeholder="doc desc"
              value={docDesc}
              onChange={(e) => setDocDesc(e.target.value)}
            />
          </Box>



          <Box p={2} >
            <Button onClick={runArtefactisation} color="primary" variant="contained" component="span" startIcon={<CloudUploadIcon />}>Do Artefactisation</Button>

          </Box>





          <Box my={2} mr={3}>
            <Button onClick={getDocs} color="primary" variant="contained" component="span" startIcon={<CloudUploadIcon />}>Get List of Docs</Button>
          </Box>
          {documents.length > 0 &&
            <div>
              <label htmlFor="documents">Choose a document:</label>
              <select
                id="document"
                value={selectedDoc}
                onChange={handleSelectDocument}
              >
                <option value="" disabled hidden>-- Select doc --</option>
                {documents.map((opt, index) => (
                  <option key={opt.itemId} value={index}>
                    {opt.name + (opt.version ? " (version " + opt.version + ")" : "")}
                  </option>
                ))}
              </select>
            </div>
          }

            */}



        </Box>


        {/*}
        <br />
        {catCols && catCols.length > 0 &&
          <Paper variant="outlined">
            <Box p={1}><h3>Select Categories</h3></Box>

            <Box p={1} display="flex" gap={2} flexDirection="row">

              {catCols.map((cats) => (
                <Box flex={1} p={2} flexDirection="column">
                  {cats.map((cat) => (
                    <label key={cat.key} style={{ display: "block", marginBottom: "4px", color: cat.status == 9 ? 'gray' : 'black' }}>
                      {cat.status > 0 &&
                        <input
                          type="checkbox"
                          value={cat.key}
                          disabled={cat.status == 9}
                          checked={selectedCategories.includes(cat.key)}
                          onChange={handleCategoryCheckboxChange}
                        />
                      }
                      {cat.status == 0 ? <><b>{cat.label}</b></> : <>&nbsp;{cat.label}</>}
                    </label>
                  ))}
                </Box>
              ))}
            </Box>
          </Paper>
        }
        <br />

        {catCols && catCols.length > 0 &&
          <>
            <TextareaAutosize
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              minRows={3}
              maxRows={10}
              style={{
                width: '100%',
                padding: 8,
                fontSize: 16,
                borderRadius: 4,
                border: '1px solid #ccc',
              }}
              placeholder="Type prompt..."
            />

            <Box my={2} >
              <select
                id="model"
                value={selectedModel}
                onChange={(e) => setSelectedModel(e.target.value)}
              >
                {models.map((model) => (
                  <option key={model.value} value={model.value}>
                    {model.label}
                  </option>
                ))}
              </select>
            </Box>


            <Box my={2} >
              <Button onClick={doQuery} color="primary" variant="contained" component="span" startIcon={<CloudUploadIcon />}>do Query</Button>
            </Box>

          </>
        }


        <Box my={3}>


          {openaiData &&
            <Paper>
              <Box p={2} >
                <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{openaiData}</pre>
              </Box>
            </Paper>
          }


          {parsedData &&
            <Paper>
              <Box p={2} >
                <pre>{JSON.stringify(parsedData, null, 2)}</pre>

              </Box>
            </Paper>
          }
        </Box>

        */}
      </>
    )
  }


  return (

    <div className="Sites">
      {isLoading ? renderLoader() : renderLander()}
      <LoadingModal open={isRunning} message={processingState.currentIndex > -1 ? `Processing file: ${processingState.currentIndex + 1} of ${processingState.fileCount} (${files[processingState.currentIndex].name})` : "Processing..."} message2={Number(resultsStatus).toFixed(2) + " seconds"}/>
      <Dialog
        open={fileDetails && fileDetails.isDuplicate}
        fullWidth={false}
        maxWidth={'md'}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" style={{ color: "#10385A" }} >
          Document Upload
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            A file with the same name (<b>{fileDetails && fileDetails.file.name}</b>) has already been uploaded. Click UPLOAD continue with the upload creating a new version (<b>v.{fileDetails && fileDetails.version}</b>) of the document.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => { setFileDetails(null) }} color="primary">
            Cancel
          </Button>
          <Button onClick={continueFileUpload} color="secondary">
            Upload
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}